import React, { useState, useEffect, useMemo, useCallback, Profiler } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { flushSync } from 'react-dom';


// Components
import Layout from "../../../../Layout/Layout";
import { InputField } from "../../../../Components/formElements/InputField";
import { getTodayDate } from "../../../../common/Validations";
import DataTable from "react-data-table-component";
// import toast from "react-hot-toast";
import EstimateMaterialSelectionModal from "./EstimateMaterialSelectionModal";
import { ComboboxField } from "../../../../Components/formElements/ComboboxField";
import toast from "react-hot-toast";
import CustomerConstants from "../../../../common/CustomerConstants";
import { useNavigate } from "react-router-dom";
import ItemService from "../../../../services/customer_appCommonService";
import { useDispatch, useSelector } from "react-redux";
import { setEstimationData } from "../../../../redux/feature/customer_app/customerV1Slice";
import EstimateUploadModal from "../Estimate/EstimateUploadModal";
// import ItemServiceV2 from "../../../../services/customer_v2_appCommonService";
import EstimateUploadDataViewModal from "../Estimate/EstimateUploadDataViewModal";
import RichTextEditor from "../../../../Components/Editor/RichTextEditor";
import { TextAreaField } from "../../../../Components/formElements/TextAreaField";
import useConfirmNavigation  from "../Estimation/useConfirmNavigation"



const calculateRowValues = (row) => {
  const code = (row.code || "").toUpperCase();
  const isBUWT = code.startsWith("BUWT") || code.startsWith("CONWT");
  const isBUF = code.startsWith("BUF");
  const isBUW = code.startsWith("BUW") && !isBUWT;

  const materialDescription = row.description || "";
  const wtModifier = Number(row.unitWeightModifier) || 1;
  const priceModifier = Number(row.unitPriceModifier) || 1;
  const pieceMeasure = Number(row.pieceMeasure) || 1;
  const quantity = Number(row.quantity) || 1;
  const unitPrice = Number(row.unitPrice) || 0;
  let xAccess = Number(row.xAccess) || 0;
  let yAccess = Number(row.yAccess) || 0;
  let unitWeight = Number(row.unitWeight) || 0;
  let pieceWeight = 0;
  let avg = "";
  let thickness = null;

  const thicknessMatch = materialDescription.match(
    /(Web\s*Thickness|Thickness)\s*[=:]?\s*([\d.]+)/i
  );
  if (thicknessMatch) thickness = parseFloat(thicknessMatch[2]);

  // Calculation logic
  if (isBUWT) {
    unitWeight = pieceMeasure;
    pieceWeight = pieceMeasure * wtModifier;
    avg = "";
  } else if (isBUF || isBUW) {
    if (isBUF) {
      yAccess = 0;
      avg = xAccess / 1000;
    } else {
      avg = (xAccess / 1000 + yAccess / 1000) / 2;
    }
    pieceWeight = avg * unitWeight * pieceMeasure * wtModifier;
  } else if (thickness !== null && unitWeight === 0) {  // 🔹 unitWeight === 0 condition added
  unitWeight = (346 * thickness * 7850) / 1000000;
  pieceWeight = pieceMeasure * unitWeight * wtModifier;
  avg = "";
} else {
  pieceWeight = unitWeight === 0
    ? pieceMeasure
    : pieceMeasure * unitWeight * wtModifier;
  avg = "";
}
  //  else {
  //   pieceWeight = pieceMeasure * unitWeight * wtModifier;
  //   avg = "";
  // }

  const totalWeight = pieceWeight * quantity;
  const price = pieceWeight * unitPrice * priceModifier;
  const totalPrice = price * quantity;

  const fix = (v, dec) => (isNaN(v) || v === null || v === "" ? "" : Number(v).toFixed(dec));

  return {
    ...row,
    unitWeight: fix(unitWeight, 3),
    avg: avg === "" ? "" : fix(avg, 3),
    pieceWeight: fix(pieceWeight, 3),
    totalWeight: fix(totalWeight, 3),
    price: fix(price, 2),
    totalPrice: fix(totalPrice, 2),
  };
};
const TableComponent = React.memo(({ 
  identifier, 
  isComponent, 
  componentBlockData, 
  activeBuildingId,
  getCurrentBlockData,
  getProductDetailsCol 
}) => {
  const data = useMemo(
    () => getCurrentBlockData(identifier), 
    // eslint-disable-next-line
    [identifier, componentBlockData, activeBuildingId, getCurrentBlockData]
  );
  
  const columns = useMemo(
    () => getProductDetailsCol(identifier, isComponent, data), 
    [identifier, isComponent, data, getProductDetailsCol]
  );

  return (
    <DataTable
      columns={columns}
      data={data}
      pagination={false}
      dense
      fixedHeader
      fixedHeaderScrollHeight="400px"
      highlightOnHover
      striped
    />
  );
});

TableComponent.displayName = 'TableComponent';


const num = (v) =>
  v === "" || v === null || v === undefined ? 0 : Number(v) || 0;

const EstimationCreation = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // const location = useLocation();
  useConfirmNavigation();

  const estimationData = useSelector(
    (state) => state.customerV1.estimationDraft.estimationData
  );

  const [isCardVisible2, setCardVisible2] = useState(true);
  // const [getDropdownData, setDropdownData] = useState("");
  const [isCardVisible6, setCardVisible6] = useState(true);
  const [isCardVisible1, setCardVisible1] = useState(true);

const [activeBuildingId, setActiveBuildingId] = useState(1);
  const [materialCatlog, setmaterialCatlog] = useState({});

  
  const [getRemarks, setRemarks] = useState({});

  // eslint-disable-next-line
  const toggleCardVisibility6 = () => setCardVisible6(!isCardVisible6);

  // const [activeBlockIndex, setActiveBlockIndex] = useState(null);  // normal blocks
  const [activeComponentKey, setActiveComponentKey] = useState(null); // component blocks
    const [buildings, setBuildings] = useState([]);
  

  const [disabled, setDisabled] = useState(false);
  const toggleCardVisibility2 = () => {
    setCardVisible2(!isCardVisible2);
  };
  // eslint-disable-next-line
  const toggleCardVisibility1 = () => {
    setCardVisible1(!isCardVisible1);
  };
  const [visibleBlocks, setVisibleBlocks] = useState({});

  const toggleCardVisibility = (key) => {
    setVisibleBlocks((prev) => ({
      ...prev,
      [key]: !prev[key], // toggle only clicked block
    }));
  };

  const [validationErrors, setValidationErrors] = useState({});
  
  const validateQtyAndPieceRow = (identifier, row) => {
    const qty = Number(row.quantity || 0);
    const piece = Number(row.pieceMeasure || 0);
  
    let errorMsg = "";
  
    if (qty === 0 && piece === 0) {
      errorMsg = "Quantity and Piece Measure cannot both be 0.";
    } 
    else if (qty === 0) {
      errorMsg = "Quantity cannot be 0.";
    }
    else if (piece === 0) {
      errorMsg = "Piece Measure cannot be 0.";
    }
  
    setValidationErrors((prev) => ({
      ...prev,
      [identifier]: {
        ...(prev[identifier] || {}),
        [row.local_id]: errorMsg
      }
    }));
  };
  
  const validateAllComponentBlocks = (componentBlockData) => {
      let errorList = [];
  
      for (const blockKey in componentBlockData) {
          const buildingData = componentBlockData[blockKey];
  
          if (!buildingData) continue;
  
          for (const buildingId in buildingData) {
              const rows = buildingData[buildingId];
  
              if (!Array.isArray(rows)) continue;
  
              for (const row of rows) {
                  if (row.code === "TOTAL") continue;
  
                  const qty = Number(row.quantity);
                  const pm = Number(row.pieceMeasure ?? row.pieceMeasurement);
  
                  // Collect errors but DON'T STOP
                  if (!qty || qty <= 0) {
                      errorList.push({
                          type: "Quantity",
                          block: blockKey,
                          building: buildingId,
                          row: row.local_id,
                      });
                  }
  
                  if (!pm || pm <= 0) {
                      errorList.push({
                          type: "Piece Measure",
                          block: blockKey,
                          building: buildingId,
                          row: row.local_id,
                      });
                  }
              }
          }
      }
  
      // After looping everything → check if errors exist
      if (errorList.length > 0) {
          let msg = " Missing Values Found:\n\n";
  
          errorList.forEach((err) => {
              msg += `${err.type} missing in:\n`;
              msg += `Component Block: ${err.block}\n`;
              msg += `Building: ${err.building}\n`;
              msg += `Row: ${err.row}\n\n`;
          });
  
          alert(msg);
          return false;
      }
  
      return true;
  };

  // total weight and cost validation 
  const validateTotals = () => {
  if (!grandTotals?.totalPrice || Number(grandTotals?.totalPrice) === 0) {
    toast.error("Estimate Cost is empty. Please calculate before saving.", {
      duration: 3000,
      position: "top-right",
    });
    return false;
  }

  if (!grandTotals?.totalWeight || Number(grandTotals?.totalWeight) === 0) {
    toast.error("Tonnage is empty. Please calculate before saving.", {
      duration: 3000,
      position: "top-right",
    });
    return false;
  }

  return true;
};

  // handleDraft
  const handleDraft = async () => {
     if (!validateTotals()) return;

     const isValid = validateAllComponentBlocks(componentBlockData);

    if (!isValid) return;

    try {
      const filteredFormInputs = Object.fromEntries(
        Object.entries(formInputs).filter(([_, value]) => {
          if (typeof value === "string") return value.trim() !== "";
          if (typeof value === "boolean") return value === true;
          return value !== null && value !== undefined;
        })
      );

      const obj = {
        ...formInputs,
        estimationDetailsRemarks: getRemarks?.estimationDetailsRemarks,
        additionalComponent: filteredFormInputs,
        grandTotalPrice: grandTotals?.totalPrice,
        grandTotalWeight: grandTotals?.totalWeight,
        componentBlocks: componentBlockData,
        buildings: buildings,
        buildingCount: buildingCount,
        activeBuildingId: activeBuildingId,
        draftStatus: "DF",
        headerStatus: "Estimation Draft",
        documentNumber: estimationData?.estimationNr || "",
      };

      setDisabled(true);
      const item = await ItemService.updateEstimation(obj);

      if (item?.status === 200) {
        const updatedData = {
          ...estimationData,
          additionalComponent: filteredFormInputs,
          componentBlocks: componentBlockData,
          buildings: buildings,
          buildingCount: buildingCount,
          activeBuildingId: activeBuildingId,

          draftStatus: "DF",
          headerStatus: "Estimation Draft",
        };
        dispatch(setEstimationData(updatedData));

        toast.success(item?.message || "Updated successfully", {
          duration: 2000,
          position: "top-right",
        });
        setDisabled(false);
        // navigate(
        //   CustomerConstants.CUSTOMER_V4_CUSTOMER_ESTIMATE_SPECIFICATION_LIST
        // );
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
    } catch (error) {
      console.error("Update failed:", error);
      toast.error("Something went wrong, please try again later!", {
        duration: 4000,
        position: "top-right",
      });
    }
  };

  const handleSave = async () => {

     if (!validateTotals()) return;
       const isValid = validateAllComponentBlocks(componentBlockData);

    if (!isValid) return;

    try {
      const filteredFormInputs = Object.fromEntries(
        Object.entries(formInputs).filter(([_, value]) => {
          if (typeof value === "string") return value.trim() !== "";
          if (typeof value === "boolean") return value === true;
          return value !== null && value !== undefined;
        })
      );

      const obj = {
        ...estimationData,
        estimationDetailsRemarks: getRemarks?.estimationDetailsRemarks,
        additionalComponent: filteredFormInputs,
        componentBlocks: componentBlockData,
        grandTotalPrice: grandTotals?.totalPrice,
        grandTotalWeight: grandTotals?.totalWeight,
        buildings: buildings,
        buildingCount: buildingCount,
        activeBuildingId: activeBuildingId,

        draftStatus: "",
        headerStatus: "Estimation Created",
        estHeaderStatus: "Estimation Created",
        documentNumber: estimationData?.estimationNr || "",
      };
      setDisabled(true);
      const item = await ItemService.updateEstimation(obj);

      if (item?.status === 200) {
        toast.success(item?.message || "Updated successfully", {
          duration: 2000,
          position: "top-right",
        });

        navigate(
          CustomerConstants.CUSTOMER_V4_CUSTOMER_ESTIMATE_SPECIFICATION_LIST
        );
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
    } catch (error) {
      console.error("Update failed:", error);
      toast.error("Something went wrong, please try again later!", {
        duration: 4000,
        position: "top-right",
      });
    }
    setDisabled(false);
  };
  const handleFormInputChange = (e) => {
    const { name, value } = e.target;

    setRemarks((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // material bocks
  const [modalShow, setModalShow] = useState(false);
  const [activeBlockIndex, setActiveBlockIndex] = useState(null);
  // eslint-disable-next-line
  const [blocks, setBlocks] = useState([
    {
      id: Date.now(),
      title: "Roof #1",
      getProductDetailsData: [],
      isVisible: true,
    },
  ]);

  const restrictDecimals = (value) => {
    if (value === "") return "";
    // allow up to 3 decimals, optional integer part
    return value.replace(/^(\d*)(\.(\d{0,3})?)?$/, (m, intPart, decPart) =>
      decPart ? (intPart || "0") + decPart : intPart
    );
  };

  /** Generic inputs (quantity, pieceMeasurement, unitPrice, …) */
  const handleInputChange = (
    blockIndex,
    local_id,
    event,
    type,
    formatOnBlur = false
  ) => {
    const { name, value } = event.target;

    let processedValue = value;

    if (name === "pieceMeasure") {
      // decimals up to 3
      if (!formatOnBlur) {
        processedValue = restrictDecimals(value);
      } else if (value !== "") {
        const num = parseFloat(value);
        processedValue = !isNaN(num) ? num.toFixed(3) : "";
      }
    } else if (name === "quantity") {
      // whole numbers only
      if (!formatOnBlur) {
        processedValue = value.replace(/[^0-9]/g, "");
      } else if (value !== "") {
        const num = parseInt(value, 10);
        processedValue = isNaN(num) ? "" : num;
      }
    } else if (type === "Number") {
      if (processedValue !== "" && isNaN(Number(processedValue))) return;
    }

    setBlocks((prev) =>
      prev.map((b, i) => {
        if (i !== blockIndex) return b;

        const updated = b.getProductDetailsData.map((row) =>
          row.local_id === local_id
            ? recalcDerived({ ...row, [name]: processedValue })
            : row
        );

        return { ...b, getProductDetailsData: updated };
      })
    );
  };

 
 
//  REPLACE handleInputChangeForComponent
const handleInputChangeForComponent = useCallback((key, local_id, event, type, onBlur = false) => {
  if (onBlur === false && type !== "Number") return;

  const { name, value } = event.target;

  flushSync(() => {
    setComponentBlockData((prev) => {
      const buildingData = prev[key]?.[activeBuildingId];
      if (!buildingData) return prev;

      const rowIndex = buildingData.findIndex(row => row.local_id === local_id);
      if (rowIndex === -1) return prev;

      const currentRow = buildingData[rowIndex];
      let updatedRow = { ...currentRow, [name]: value };
      updatedRow = calculateRowValues(updatedRow);

      const newBuildingData = [...buildingData];
      newBuildingData[rowIndex] = updatedRow;

      return {
        ...prev,
        [key]: {
          ...prev[key],
          [activeBuildingId]: newBuildingData,
        },
      };
    });
  });
}, [activeBuildingId]);

//  REPLACE handleMaterialCodeChangeForComponent
// const handleMaterialCodeChangeForComponent = useCallback((key, local_id, codeInput, selectedMaterial) => {
//   flushSync(() => {
//     setComponentBlockData((prev) => {
//       const buildingData = prev[key]?.[activeBuildingId] || [];

//       return {
//         ...prev,
//         [key]: {
//           ...prev[key],
//           [activeBuildingId]: buildingData.map((row) => {
//             if (row.local_id !== local_id) return row;

//             if (!selectedMaterial) {
//               return {
//                 ...row,
//                 code: codeInput,
//                 description: "",
//                 unit: "",
//                 unitWeight: "",
//                 pieceWeight: "",
//                 unitPrice: "",
//                 totalWeight: "",
//                 price: "",
//                 totalPrice: "",
//                 unitWeightModifier: "",
//                 unitPriceModifier: "",
//                 xAccess: "",
//                 yAccess: "",
//                 materialLongDescription: "",
//                 avg: "",
//                 isPieceMeasureLocked: false,
//               };
//             }

//             let unitWeight = Number(selectedMaterial.unitWeight) || 0;
//             const materialDescription =
//               selectedMaterial.materialDescription ||
//               selectedMaterial.description ||
//               selectedMaterial.name ||
//               "";
//             const unitPrice = Number(selectedMaterial.unitPrice) || 0;
//             const wtModifier = Number(selectedMaterial.unitWeightModifier) || 1;
//             const priceModifier = Number(selectedMaterial.unitPriceModifier) || 1;
//             const quantity = Number(row.quantity) || 1;

//             let pieceWeight = 0;
//             let totalWeight = 0;
//             let price = 0;
//             let totalPrice = 0;
//             let avg = "";
//             let thickness = null;

//             const thicknessMatch = materialDescription.match(
//               /(Web\s*Thickness|Thickness)\s*[=:]?\s*([\d.]+)/i
//             );
//             const code = (
//               selectedMaterial.materialCode ||
//               selectedMaterial.code ||
//               ""
//             ).toUpperCase();
//             let xAccess = Number(selectedMaterial.xAccess) || 0;
//             let yAccess = Number(selectedMaterial.yAccess) || 0;

//             const isSpecialCode =
//               code.startsWith("AB") ||
//               code.startsWith("MS") ||
//               code.startsWith("HT");
//             const isBUWT = code.startsWith("BUWT");
//             const isBUW = code.startsWith("BUW") && !isBUWT;

//             let pieceMeasure = Number(row.pieceMeasure) || 1;
//             let isPieceMeasureLocked = isSpecialCode;
//             if (isPieceMeasureLocked) pieceMeasure = 1;

//             if (thicknessMatch) thickness = parseFloat(thicknessMatch[2]);

//             const isCONWT_BUWT = code.startsWith("CONWT") || isBUWT;
//             const unitWeightFromCatalogIsZero = !unitWeight || unitWeight === 0;

//             if (isCONWT_BUWT && unitWeightFromCatalogIsZero) {
//               unitWeight = Number(pieceMeasure) || 0;
//             }

//             if (code.startsWith("BUF")) {
//               avg = xAccess / 1000;
//               yAccess = 0;
//               pieceWeight = avg * unitWeight * pieceMeasure * wtModifier;
//               totalWeight = pieceWeight * quantity;
//               price = pieceWeight * unitPrice * priceModifier;
//               totalPrice = price * quantity;
//             } else if (isBUW) {
//               avg = (xAccess / 1000 + yAccess / 1000) / 2;
//               pieceWeight = avg * unitWeight * pieceMeasure * wtModifier;
//               totalWeight = pieceWeight * quantity;
//               price = pieceWeight * unitPrice * priceModifier;
//               totalPrice = price * quantity;
//             } else if (thickness !== null) {
//               unitWeight = (346 * thickness * 7850) / 10000;
//               pieceWeight = pieceMeasure * unitWeight * wtModifier;
//               totalWeight = pieceWeight * quantity;
//               price = pieceWeight * unitPrice * priceModifier;
//               totalPrice = price * quantity;
//               avg = "";
//               xAccess = "";
//               yAccess = "";
//             } else {
//               pieceWeight = pieceMeasure * unitWeight * wtModifier;
//               totalWeight = pieceWeight * quantity;
//               price = pieceMeasure * unitWeight * wtModifier * unitPrice * priceModifier;
//               totalPrice = price * quantity;
//               avg = "";
//               xAccess = "";
//               yAccess = "";
//             }

//             if (isCONWT_BUWT && unitWeightFromCatalogIsZero) {
//               price = Number(pieceMeasure || 0) * unitPrice;
//               totalPrice = price * quantity;
//               pieceWeight = Number(pieceMeasure || 0) * (wtModifier || 1);
//               totalWeight = pieceWeight * quantity;
//             }

//             const fix = (v, dec) =>
//               isNaN(v) || v === null || v === "" ? "" : Number(v).toFixed(dec);

//             return {
//               ...row,
//               code: selectedMaterial.materialCode || selectedMaterial.code || "",
//               description: materialDescription,
//               unit: selectedMaterial.unit || "",
//               unitWeight: fix(unitWeight, 3),
//               unitPrice: fix(unitPrice, 2),
//               unitWeightModifier: wtModifier,
//               unitPriceModifier: priceModifier,
//               xAccess: code.startsWith("BUW") || code.startsWith("BUF") ? xAccess : "",
//               yAccess: code.startsWith("BUW") || code.startsWith("BUF") ? yAccess : "",
//               avg: avg === "" ? "" : fix(avg, 3),
//               pieceMeasure: pieceMeasure,
//               isPieceMeasureLocked,
//               pieceWeight: fix(pieceWeight, 3),
//               totalWeight: fix(totalWeight, 3),
//               price: fix(price, 2),
//               totalPrice: fix(totalPrice, 2),
//             };
//           }),
//         },
//       };
//     });
//   });
//   // eslint-disable-next-line
// }, [activeBuildingId, materialCatlog]);


const handleMaterialCodeChangeForComponent = useCallback((key, local_id, codeInput, selectedMaterial) => {
  flushSync(() => {
    setComponentBlockData((prev) => {
      const buildingData = prev[key]?.[activeBuildingId] || [];

      return {
        ...prev,
        [key]: {
          ...prev[key],
          [activeBuildingId]: buildingData.map((row) => {
            if (row.local_id !== local_id) return row;

            if (!selectedMaterial) {
              return {
                ...row,
                code: codeInput,
                description: "",
                unit: "",
                unitWeight: "",
                pieceWeight: "",
                unitPrice: "",
                totalWeight: "",
                price: "",
                totalPrice: "",
                unitWeightModifier: "",
                unitPriceModifier: "",
                xAccess: "",
                yAccess: "",
                materialLongDescription: "",
                avg: "",
                isPieceMeasureLocked: false,
              };
            }

            let unitWeight = Number(selectedMaterial.unitWeight) || 0;
            const materialDescription =
              selectedMaterial.materialDescription ||
              selectedMaterial.description ||
              selectedMaterial.name ||
              "";
            const unitPrice = Number(selectedMaterial.unitPrice) || 0;
            const wtModifier = Number(selectedMaterial.unitWeightModifier) || 1;
            const priceModifier = Number(selectedMaterial.unitPriceModifier) || 1;
            const quantity = Number(row.quantity) || 1;

            let pieceWeight = 0;
            let totalWeight = 0;
            let price = 0;
            let totalPrice = 0;
            let avg = "";
            let thickness = null;

            const thicknessMatch = materialDescription.match(
              /(Web\s*Thickness|Thickness)\s*[=:]?\s*([\d.]+)/i
            );
            const code = (
              selectedMaterial.materialCode ||
              selectedMaterial.code ||
              ""
            ).toUpperCase();
            let xAccess = Number(selectedMaterial.xAccess) || 0;
            let yAccess = Number(selectedMaterial.yAccess) || 0;

            const isSpecialCode =
              code.startsWith("AB") ||
              code.startsWith("MS") ||
              code.startsWith("HT");
            const isBUWT = code.startsWith("BUWT");
            const isBUW = code.startsWith("BUW") && !isBUWT;

            let pieceMeasure = Number(row.pieceMeasure) || 1;
            let isPieceMeasureLocked = isSpecialCode;
            if (isPieceMeasureLocked) pieceMeasure = 1;

            if (thicknessMatch) thickness = parseFloat(thicknessMatch[2]);

            const isCONWT_BUWT = code.startsWith("CONWT") || isBUWT;
            const unitWeightFromCatalogIsZero = !unitWeight || unitWeight === 0;

            if (isCONWT_BUWT && unitWeightFromCatalogIsZero) {
              unitWeight = Number(pieceMeasure) || 0;
            }

            // ✅ EXCLUDE SPECIFIC CODES FROM RECALCULATION
            const excludeCodes = ["APCHS", "FB", "SA"];
            const isExcludedCode = excludeCodes.some(prefix => code.startsWith(prefix));

            // ✅ NEW LOGIC WITH EXCLUSION CHECK
            if (isExcludedCode) {
              // For APCHS, FB, SA: ALWAYS use database unitWeight (NO recalculation)
              pieceWeight = pieceMeasure * unitWeight * wtModifier;
              totalWeight = pieceWeight * quantity;
              price = pieceWeight * unitPrice * priceModifier;
              totalPrice = price * quantity;
              avg = "";
            }
            else if (code.startsWith("BUF")) {
              avg = xAccess / 1000;
              yAccess = 0;
              pieceWeight = avg * unitWeight * pieceMeasure * wtModifier;
              totalWeight = pieceWeight * quantity;
              price = pieceWeight * unitPrice * priceModifier;
              totalPrice = price * quantity;
            }
            else if (isBUW) {
              avg = (xAccess / 1000 + yAccess / 1000) / 2;
              pieceWeight = avg * unitWeight * pieceMeasure * wtModifier;
              totalWeight = pieceWeight * quantity;
              price = pieceWeight * unitPrice * priceModifier;
              totalPrice = price * quantity;
            }
            // else if (thickness !== null) {
              else if (thickness !== null && (!unitWeight || unitWeight === 0)) {
              unitWeight = (346 * thickness * 7850) / 1000000;
              pieceWeight = pieceMeasure * unitWeight * wtModifier;
              totalWeight = pieceWeight * quantity;
              price = pieceWeight * unitPrice * priceModifier;
              totalPrice = price * quantity;
              avg = "";
              xAccess = "";
              yAccess = "";
            } else {
  pieceWeight = unitWeight === 0
    ? pieceMeasure
    : pieceMeasure * unitWeight * wtModifier;
  totalWeight = pieceWeight * quantity;
  price = pieceWeight * unitPrice * priceModifier;
  totalPrice = price * quantity;
  avg = "";
  xAccess = "";
  yAccess = "";
}
            // else {
            //   pieceWeight = pieceMeasure * unitWeight * wtModifier;
            //   totalWeight = pieceWeight * quantity;
            //   price = pieceWeight * unitPrice * priceModifier;
            //   totalPrice = price * quantity;
            //   avg = "";
            //   xAccess = "";
            //   yAccess = "";
            // }

            if (isCONWT_BUWT && unitWeightFromCatalogIsZero) {
              price = Number(pieceMeasure || 0) * unitPrice;
              totalPrice = price * quantity;
              pieceWeight = Number(pieceMeasure || 0) * (wtModifier || 1);
              totalWeight = pieceWeight * quantity;
            }

            const fix = (v, dec) =>
              isNaN(v) || v === null || v === "" ? "" : Number(v).toFixed(dec);

            return {
              ...row,
              code: selectedMaterial.materialCode || selectedMaterial.code || "",
              description: materialDescription,
              unit: selectedMaterial.unit || "",
              unitWeight: fix(unitWeight, 3),
              unitPrice: fix(unitPrice, 2),
              unitWeightModifier: wtModifier,
              unitPriceModifier: priceModifier,
              xAccess: code.startsWith("BUW") || code.startsWith("BUF") ? xAccess : "",
              yAccess: code.startsWith("BUW") || code.startsWith("BUF") ? yAccess : "",
              avg: avg === "" ? "" : fix(avg, 3),
              pieceMeasure: pieceMeasure,
              isPieceMeasureLocked,
              pieceWeight: fix(pieceWeight, 3),
              totalWeight: fix(totalWeight, 3),
              price: fix(price, 2),
              totalPrice: fix(totalPrice, 2),
            };
          }),
        },
      };
    });
  });
  // eslint-disable-next-line
}, [activeBuildingId, materialCatlog]);


 
  /** Delete only inside that block */
  const removeProductDetails = (blockIndex, local_id) => {
    setBlocks((prev) =>
      prev.map((b, i) => {
        if (i !== blockIndex) return b;
        const filtered = b.getProductDetailsData
          .filter((r) => r.local_id !== local_id)
          .map((r, idx) => ({ ...r, local_id: idx + 1 }));
        return { ...b, getProductDetailsData: filtered };
      })
    );
  };

  const removeProductDetailsForComponent = (key, local_id) => {
    setComponentBlockData((prev) => {
      const buildingData = prev[key]?.[activeBuildingId] || [];
      const filtered = buildingData
        .filter((r) => r.local_id !== local_id)
        .map((r, idx) => ({ ...r, local_id: idx + 1 }));

      return {
        ...prev,
        [key]: {
          ...prev[key],
          [activeBuildingId]: filtered,
        },
      };
    });
  };

  // const handleMaterialCodeChange = (blockIndex, local_id, codeInput) => {
  //   const inputCode = (codeInput || "").toUpperCase().trim();
  //   const isSpecialCode =
  //     inputCode.startsWith("AB") ||
  //     inputCode.startsWith("MS") ||
  //     inputCode.startsWith("HT");
 
  //   setBlocks((prev) =>
  //     prev.map((block, i) => {
  //       if (i !== blockIndex) return block;
 
  //       const updatedRows = block.getProductDetailsData.map((row) => {
  //         if (row.local_id !== local_id) return row;
 
  //         const match = materialCatlog.find(
  //           (m) => (m.code || "").toUpperCase() === inputCode
  //         );
 
  //         if (!match) {
  //           return {
  //             ...row,
  //             materialCode: codeInput,
  //             description: "",
  //             uOM: "",
  //             unitWeight: "",
  //             pieceWeight: "",
  //             unitPrice: "",
  //             totalWeight: "",
  //             price: "",
  //             totalPrice: "",
  //             xAccess: "",
  //             yAccess: "",
  //             avg: "",
  //             isPieceMeasureLocked: false,
  //           };
  //         }
 
  //         const code = match.code.toUpperCase();
 
  //         const isBUF = code.startsWith("BUF");
  //         const isBUWT = code.startsWith("BUWT");
  //         const isBUW = code.startsWith("BUW") && !isBUWT;
  //         const isCONWT = code.startsWith("CONWT");
 
  //         let xAccess = Number(row.xAccess) || 0;
  //         let yAccess = Number(row.yAccess) || 0;
  //         let avg = "";
 
  //         if (isBUF) {
  //           avg = xAccess / 1000;
  //           yAccess = 0;
  //         } else if (isBUW) {
  //           avg = (xAccess / 1000 + yAccess / 1000) / 2;
  //         } else {
  //           xAccess = "";
  //           yAccess = "";
  //         }
 
  //         let pieceMeasure = Number(row.pieceMeasurement) || 1;
  //         let isPieceMeasureLocked = isSpecialCode;
  //         if (isPieceMeasureLocked) pieceMeasure = 1;
 
  //         let unitWeight = Number(match.unitWeight) || 0;
  //         const wtModifier = Number(match.unitWeightModifier) || 1;
  //         const unitPrice = Number(match.unitPrice) || 0;
  //         const quantity = Number(row.quantity) || 1;
 
  //         // ✅ CONWT rule
  //         if (isCONWT && (!unitWeight || unitWeight === 0)) {
  //           unitWeight = pieceMeasure;
  //         }
 
  //         // ✅ BUWT rule (ALWAYS)
  //         if (isBUWT) {
  //           unitWeight = pieceMeasure;
  //         }
 
  //         let pieceWeight = 0;
  //         let totalWeight = 0;
  //         let price = 0;
  //         let totalPrice = 0;
 
  //         if (isBUF || isBUW) {
  //           pieceWeight = avg * unitWeight * pieceMeasure * wtModifier;
  //         } else {
  //           pieceWeight = pieceMeasure * unitWeight * wtModifier;
  //         }
 
  //         totalWeight = pieceWeight;
  //         price = totalWeight * unitPrice;
  //         totalPrice = price * quantity;
 
  //         // ✅ FINAL OVERRIDE FOR CONWT & BUWT
  //         // if (isCONWT || isBUWT) {
  //         //   pieceWeight = pieceMeasure * wtModifier;
  //         //   totalWeight = pieceWeight;
  //         //   price = pieceMeasure * unitPrice;
  //         //   totalPrice = price * quantity;
  //         //   avg = "";
  //         //   xAccess = "";
  //         //   yAccess = "";
  //         // }
 
  //         // ✅ NEW LOGIC FOR BUWT/CONWT (Replace your existing override block)
  //         if (isBUWT || isCONWT) {
  //           unitWeight = pieceMeasure; // The measure is the weight
  //           pieceWeight = pieceMeasure * wtModifier;
  //           totalWeight = pieceWeight * quantity;
  //           price = pieceMeasure * unitPrice; // Price based on weight entry
  //           totalPrice = price * quantity;
  //           avg = "";
  //           xAccess = "";
  //           yAccess = "";
  //         }
 
  //         return {
  //           ...row,
  //           materialCode: match.code,
  //           description: match.description,
  //           uOM: match.unit,
  //           unitWeight: unitWeight.toFixed(3),
  //           pieceWeight: pieceWeight.toFixed(3),
  //           unitPrice: unitPrice.toFixed(2),
  //           totalWeight: totalWeight.toFixed(3),
  //           price: price.toFixed(2),
  //           totalPrice: totalPrice.toFixed(2),
  //           xAccess: isBUF || isBUW ? xAccess : "",
  //           yAccess: isBUF || isBUW ? yAccess : "",
  //           avg: avg === "" ? "" : avg.toFixed(3),
  //           pieceMeasurement: pieceMeasure,
  //           isPieceMeasureLocked,
  //         };
  //       });
 
  //       return {
  //         ...block,
  //         getProductDetailsData: updatedRows,
  //       };
  //     })
  //   );
  // };
 

  
const handleMaterialCodeChange = (blockIndex, local_id, codeInput) => {
  const inputCode = (codeInput || "").toUpperCase().trim();
  const isSpecialCode =
    inputCode.startsWith("AB") ||
    inputCode.startsWith("MS") ||
    inputCode.startsWith("HT");

  setBlocks((prev) =>
    prev.map((block, i) => {
      if (i !== blockIndex) return block;

      const updatedRows = block.getProductDetailsData.map((row) => {
        if (row.local_id !== local_id) return row;

        const match = materialCatlog.find(
          (m) => (m.code || "").toUpperCase() === inputCode
        );

        if (!match) {
          return {
            ...row,
            materialCode: codeInput,
            description: "",
            uOM: "",
            unitWeight: "",
            pieceWeight: "",
            unitPrice: "",
            totalWeight: "",
            price: "",
            totalPrice: "",
            xAccess: "",
            yAccess: "",
            avg: "",
            isPieceMeasureLocked: false,
          };
        }

        const code = match.code.toUpperCase();

        const isBUF = code.startsWith("BUF");
        const isBUWT = code.startsWith("BUWT");
        const isBUW = code.startsWith("BUW") && !isBUWT;
        const isCONWT = code.startsWith("CONWT");

        //  EXCLUDE SPECIFIC CODES FROM RECALCULATION
        const excludeCodes = ["APCHS", "FB", "SA"];
        const isExcludedCode = excludeCodes.some(prefix => code.startsWith(prefix));

        let xAccess = Number(row.xAccess) || 0;
        let yAccess = Number(row.yAccess) || 0;
        let avg = "";

        if (isBUF) {
          avg = xAccess / 1000;
          yAccess = 0;
        } else if (isBUW) {
          avg = (xAccess / 1000 + yAccess / 1000) / 2;
        } else {
          xAccess = "";
          yAccess = "";
        }

        let pieceMeasure = Number(row.pieceMeasurement) || 1;
        let isPieceMeasureLocked = isSpecialCode;
        if (isPieceMeasureLocked) pieceMeasure = 1;

        let unitWeight = Number(match.unitWeight) || 0;
        const wtModifier = Number(match.unitWeightModifier) || 1;
        const unitPrice = Number(match.unitPrice) || 0;
        const quantity = Number(row.quantity) || 1;

        //  CONWT rule
        if (isCONWT && (!unitWeight || unitWeight === 0)) {
          unitWeight = pieceMeasure;
        }

        //  BUWT rule (ALWAYS)
        if (isBUWT) {
          unitWeight = pieceMeasure;
        }

        let pieceWeight = 0;
        let totalWeight = 0;
        let price = 0;
        let totalPrice = 0;

        //  NEW LOGIC WITH EXCLUSION CHECK
        if (isExcludedCode) {
          // For APCHS, FB, SA: ALWAYS use database unitWeight (NO recalculation)
          pieceWeight = pieceMeasure * unitWeight * wtModifier;
          totalWeight = pieceWeight * quantity;
          price = pieceWeight * unitPrice;
          totalPrice = price * quantity;
        }
        else if (isBUF || isBUW) {
          pieceWeight = avg * unitWeight * pieceMeasure * wtModifier;
          totalWeight = pieceWeight * quantity;
          price = pieceWeight * unitPrice;
          totalPrice = price * quantity;
        }
        else {
          pieceWeight = pieceMeasure * unitWeight * wtModifier;
          totalWeight = pieceWeight * quantity;
          price = pieceWeight * unitPrice;
          totalPrice = price * quantity;
        }

        return {
          ...row,
          materialCode: match.code,
          description: match.description,
          uOM: match.unit,
          unitWeight: unitWeight.toFixed(3),
          pieceWeight: pieceWeight.toFixed(3),
          unitPrice: unitPrice.toFixed(2),
          totalWeight: totalWeight.toFixed(3),
          price: price.toFixed(2),
          totalPrice: totalPrice.toFixed(2),
          xAccess: isBUF || isBUW ? xAccess : "",
          yAccess: isBUF || isBUW ? yAccess : "",
          avg: avg === "" ? "" : avg.toFixed(3),
          pieceMeasurement: pieceMeasure,
          isPieceMeasureLocked,
        };
      });

      return {
        ...block,
        getProductDetailsData: updatedRows,
      };
    })
  );
};



 
  
  const handleGetSelectedMaterial = (selectedData, blockIndex) => {
    setBlocks((prev) =>
      prev.map((b, i) => {
        if (i !== blockIndex) return b;
 
        const merged = [
          ...b.getProductDetailsData,
          ...selectedData.map((item, idx) => {
            const code = (item.code || "").toUpperCase();
            const isSpecialCode =
              code.startsWith("AB") ||
              code.startsWith("MS") ||
              code.startsWith("HT");
 
            const descText = (
              item.description ||
              item.materialLongText ||
              item.materialDescription ||
              item.name ||
              ""
            ).toString();
 
            const thicknessMatch = descText.match(
              /thickness\s*[:=]\s*([\d.]+)/i
            );
            const thickness = thicknessMatch
              ? parseFloat(thicknessMatch[1])
              : null;
 
            let xAccess = Number(item.xAccess) || 0;
            let yAccess = Number(item.yAccess) || 0;
            let unitWeight = Number(item.unitWeight) || 0;
            const wtModifier = Number(item.unitWeightModifier) || 1;
            const unitPrice = Number(item.unitPrice) || 0;
            const quantity = Number(item.quantity) || 1;
 
            let avg = "";
            let pieceWeight = 0;
            let totalWeight = 0;
            let totalPrice = 0;
            let price = 0;
 
            let pieceMeasure = Number(item.pieceMeasure) || 1;
            let isPieceMeasureLocked = isSpecialCode;
            if (isPieceMeasureLocked) pieceMeasure = 1;
 
            const isBUWT = code.startsWith("BUWT");
            const isBUW = code.startsWith("BUW") && !isBUWT;
            const isCONWT_BUWT = code.startsWith("CONWT") || isBUWT;
            const unitWeightFromCatalogIsZero = !unitWeight || unitWeight === 0;
 
            if (isCONWT_BUWT && unitWeightFromCatalogIsZero) {
              unitWeight = Number(pieceMeasure) || 0;
            }
 
            if (code.startsWith("BUF")) {
              avg = xAccess / 1000;
              yAccess = 0;
              pieceWeight = avg * unitWeight * pieceMeasure * wtModifier;
              totalWeight = pieceWeight;
              totalPrice = totalWeight * unitPrice;
              price = totalPrice * quantity;
            } else if (isBUW) {
              avg = (xAccess / 1000 + yAccess / 1000) / 2;
              pieceWeight = avg * unitWeight * pieceMeasure * wtModifier;
              totalWeight = pieceWeight;
              totalPrice = totalWeight * unitPrice;
              price = totalPrice * quantity;
            } else if (thickness) {
              pieceWeight = thickness * unitWeight * pieceMeasure * wtModifier;
              totalWeight = pieceWeight;
              totalWeight = pieceWeight;
              totalPrice = totalWeight * unitPrice;
              price = totalPrice * quantity;
              avg = "";
              xAccess = "";
              yAccess = "";
            } else {
              pieceWeight = pieceMeasure * unitWeight * wtModifier;
              totalWeight = pieceWeight;
              totalPrice = totalWeight * unitPrice;
              price = totalPrice * quantity;
              avg = "";
              xAccess = "";
              yAccess = "";
            }
 
            if (isCONWT_BUWT && unitWeightFromCatalogIsZero) {
              price = Number(pieceMeasure || 0) * unitPrice;
              totalPrice = price * quantity;
              pieceWeight = Number(pieceMeasure || 0) * (wtModifier || 1);
              totalWeight = pieceWeight;
            }
 
            return {
              local_id: b.getProductDetailsData.length + idx + 1,
              materialCode: item.code || "",
              materialLongText: descText,
              uOM: item.unit || "",
              unitWeight,
              pieceWeight: Number(pieceWeight).toFixed(3),
              quantity,
              pieceMeasurement: pieceMeasure,
              unitPrice,
              totalWeight: Number(totalWeight).toFixed(3),
              price: Number(price).toFixed(2),
              totalPrice: Number(totalPrice).toFixed(2),
              unitValue: wtModifier,
              xAccess:
                code.startsWith("BUW") || code.startsWith("BUF") ? xAccess : "",
              yAccess:
                code.startsWith("BUW") || code.startsWith("BUF") ? yAccess : "",
              accOnOff: false,
              orderQuantityLoad: "",
              dispatchDate: getTodayDate(""),
              orderStatus: "Pending",
              avg: avg === "" ? "" : Number(avg).toFixed(3),
              isPieceMeasureLocked,
            };
          }),
        ];
 
        return {
          ...b,
          getProductDetailsData: merged.map((row, idx) => ({
            ...row,
            local_id: idx + 1,
          })),
        };
      })
    );
  };
 
 
//   const handleGetSelectedMaterialForComponent = (selectedData, key) => {
//   setComponentBlockData((prev) => {
    
//     const current = prev[key]?.[activeBuildingId] || [];
    
 
//     const newData = [
//       ...current,
//       ...selectedData.map((item, idx) => {
//         const code = (item.code || "").toString().toUpperCase();
//         const isSpecialCode =
//           code.startsWith("AB") || code.startsWith("MS") || code.startsWith("HT");
       
//         const num = (v, def = 0) => (isNaN(Number(v)) ? def : Number(v));
 
//         // --- Basic Setup ---
//         let unitWeight = num(item.unitWeight);
//         let wtModifier = num(item.unitWeightModifier, 1);
//         let unitPrice = num(item.unitPrice);
//         let quantity = num(item.quantity, 1);
//         let pieceMeasure = num(item.pieceMeasure, 1);
       
//         // Locking logic
//         let isPieceMeasureLocked = isSpecialCode;
//         if (isPieceMeasureLocked) pieceMeasure = 1;
 
//         let avg = "";
//         let pieceWeight = 0;
//         let totalWeight = 0;
//         let totalPrice = 0;
//         let price = 0;
//         let xAccess = num(item.xAccess);
//         let yAccess = num(item.yAccess);
 
//         const descText = (item.description || item.materialLongText || item.materialDescription || item.name || "").toString();
//         const thicknessMatch = descText.match(/(Web\s*Thickness|Thickness)\s*[=:]?\s*([\d.]+)/i);
//         let thickness = thicknessMatch ? parseFloat(thicknessMatch[2]) : null;
 
//         const fix = (v, dec) => (isNaN(v) || v === null || v === "" ? "" : Number(v).toFixed(dec));
        
 
//         // --- CORE CALCULATION LOGIC ---
       
//         const isBUWT = code.startsWith("BUWT");
//         const isCONWT = code.startsWith("CONWT");
//         const isBUW = code.startsWith("BUW") && !isBUWT;
 
//         // CASE 1: BUWT or CONWT (Weight = Measure)
//         if (isBUWT || isCONWT) {
//           unitWeight = pieceMeasure;
//           pieceWeight = pieceMeasure * wtModifier;
//           totalWeight = pieceWeight * quantity;
//           price = pieceMeasure * unitPrice;
//           totalPrice = price * quantity;
//           avg = "";
//           xAccess = "";
//           yAccess = "";
//         }
//         // CASE 2: BUF (Surface area based)
//         else if (code.startsWith("BUF")) {
//           avg = xAccess / 1000;
//           yAccess = 0;
//           pieceWeight = avg * unitWeight * pieceMeasure * wtModifier;
//           totalWeight = pieceWeight * quantity;
//           price = pieceWeight * unitPrice * num(item.unitPriceModifier, 1);
//           totalPrice = price * quantity;
//         }
//         // CASE 3: BUW (Average Depth based)
//         else if (isBUW) {
//           avg = (xAccess / 1000 + yAccess / 1000) / 2;
//           pieceWeight = avg * unitWeight * pieceMeasure * wtModifier;
//           totalWeight = pieceWeight * quantity;
//           price = pieceWeight * unitPrice * num(item.unitPriceModifier, 1);
//           totalPrice = price * quantity;
//         }
//         // CASE 4: Thickness formula
//         else if (thickness !== null) {
//           unitWeight = (346 * thickness * 7850) / 10000;
//           pieceWeight = pieceMeasure * unitWeight * wtModifier;
//           totalWeight = pieceWeight * quantity;
//           price = pieceWeight * unitPrice * num(item.unitPriceModifier, 1);
//           totalPrice = price * quantity;
//           avg = "";
//         }
//         // CASE 5: Default standard material
//         else {
//           pieceWeight = pieceMeasure * unitWeight * wtModifier;
//           totalWeight = pieceWeight * quantity;
//           price = pieceWeight * unitPrice * num(item.unitPriceModifier, 1);
//           totalPrice = price * quantity;
//           avg = "";
//         }
 
//         return {
//           local_id: current.length + idx + 1,
//           code,
//           description: descText,
//           quantity,
//           pieceMeasure,
//           isPieceMeasureLocked,
//           unit: item.unit || "",
//           unitWeight: fix(unitWeight, 3),
//           unitPrice: fix(unitPrice, 2),
//           pieceWeight: fix(pieceWeight, 3),
//           totalWeight: fix(totalWeight, 3),
//           price: fix(price, 2),
//           totalPrice: fix(totalPrice, 2),
//           unitWeightModifier: wtModifier,
//           unitPriceModifier: item.unitPriceModifier || "1",
//           xAccess: (code.startsWith("BUW") || code.startsWith("BUF")) ? xAccess : "",
//           yAccess: (code.startsWith("BUW") || code.startsWith("BUF")) ? yAccess : "",
//           avg: avg === "" ? "" : fix(avg, 3),
//         };
//       }),
//     ];
 
//     const reindexed = newData.map((i, index) => ({
//       ...i,
//       local_id: index + 1,
//     }));
 
//     return {
//       ...prev,
//       [key]: {
//         ...prev[key],
//         [activeBuildingId]: reindexed,
//       },
//     };
//   });
// };
 



  //load matreila data


 const handleGetSelectedMaterialForComponent = (selectedData, key) => {
  setComponentBlockData((prev) => {
    const current = prev[key]?.[activeBuildingId] || [];

    const newData = [
      ...current,
      ...selectedData.map((item, idx) => {
        const code = (item.code || "").toString().toUpperCase();
        const isSpecialCode =
          code.startsWith("AB") || code.startsWith("MS") || code.startsWith("HT");

        const num = (v, def = 0) => (isNaN(Number(v)) ? def : Number(v));

        // --- Basic Setup ---
        let unitWeight = num(item.unitWeight);
        let wtModifier = num(item.unitWeightModifier, 1);
        let unitPrice = num(item.unitPrice);
        let quantity = num(item.quantity, 1);
        let pieceMeasure = num(item.pieceMeasure, 1);

        // Locking logic
        let isPieceMeasureLocked = isSpecialCode;
        if (isPieceMeasureLocked) pieceMeasure = 1;

        let avg = "";
        let pieceWeight = 0;
        let totalWeight = 0;
        let totalPrice = 0;
        let price = 0;
        let xAccess = num(item.xAccess);
        let yAccess = num(item.yAccess);

        const descText = (item.description || item.materialLongText || item.materialDescription || item.name || "").toString();
        const thicknessMatch = descText.match(/(Web\s*Thickness|Thickness)\s*[=:]?\s*([\d.]+)/i);
        let thickness = thicknessMatch ? parseFloat(thicknessMatch[2]) : null;

        const fix = (v, dec) => (isNaN(v) || v === null || v === "" ? "" : Number(v).toFixed(dec));

        // --- CORE CALCULATION LOGIC ---

        const isBUWT = code.startsWith("BUWT");
        const isCONWT = code.startsWith("CONWT");
        const isBUW = code.startsWith("BUW") && !isBUWT;

        //  EXCLUDE SPECIFIC CODES FROM RECALCULATION
        const excludeCodes = ["APCHS", "FB", "SA"];
        const isExcludedCode = excludeCodes.some(prefix => code.startsWith(prefix));

        //  NEW LOGIC WITH EXCLUSION CHECK
        if (isExcludedCode) {
          // For APCHS, FB, SA: ALWAYS use database unitWeight (NO recalculation)
          pieceWeight = pieceMeasure * unitWeight * wtModifier;
          totalWeight = pieceWeight * quantity;
          price = pieceWeight * unitPrice * num(item.unitPriceModifier, 1);
          totalPrice = price * quantity;
          avg = "";
          xAccess = (code.startsWith("BUW") || code.startsWith("BUF")) ? xAccess : "";
          yAccess = (code.startsWith("BUW") || code.startsWith("BUF")) ? yAccess : "";
        }
        // CASE 1: BUWT or CONWT (Weight = Measure)
        else if (isBUWT || isCONWT) {
          unitWeight = pieceMeasure;
          pieceWeight = pieceMeasure * wtModifier;
          totalWeight = pieceWeight * quantity;
          price = pieceMeasure * unitPrice;
          totalPrice = price * quantity;
          avg = "";
          xAccess = "";
          yAccess = "";
        }
        // CASE 2: BUF (Surface area based)
        else if (code.startsWith("BUF")) {
          avg = xAccess / 1000;
          yAccess = 0;
          pieceWeight = avg * unitWeight * pieceMeasure * wtModifier;
          totalWeight = pieceWeight * quantity;
          price = pieceWeight * unitPrice * num(item.unitPriceModifier, 1);
          totalPrice = price * quantity;
        }
        // CASE 3: BUW (Average Depth based)
        else if (isBUW) {
          avg = (xAccess / 1000 + yAccess / 1000) / 2;
          pieceWeight = avg * unitWeight * pieceMeasure * wtModifier;
          totalWeight = pieceWeight * quantity;
          price = pieceWeight * unitPrice * num(item.unitPriceModifier, 1);
          totalPrice = price * quantity;
        }
        // CASE 4: Thickness formula (only if DB weight is missing/zero)
        else if (thickness !== null && (!unitWeight || unitWeight === 0)) {
          unitWeight = (346 * thickness * 7850) / 1000000;
          pieceWeight = pieceMeasure * unitWeight * wtModifier;
          totalWeight = pieceWeight * quantity;
          price = pieceWeight * unitPrice * num(item.unitPriceModifier, 1);
          totalPrice = price * quantity;
          avg = "";
        } else {
  pieceWeight = unitWeight === 0
    ? pieceMeasure
    : pieceMeasure * unitWeight * wtModifier;
  totalWeight = pieceWeight * quantity;
  price = pieceWeight * unitPrice * num(item.unitPriceModifier, 1);
  totalPrice = price * quantity;
  avg = "";
}
        // CASE 5: Default standard material
        // else {
        //   pieceWeight = pieceMeasure * unitWeight * wtModifier;
        //   totalWeight = pieceWeight * quantity;
        //   price = pieceWeight * unitPrice * num(item.unitPriceModifier, 1);
        //   totalPrice = price * quantity;
        //   avg = "";
        // }

        return {
          local_id: current.length + idx + 1,
          code,
          description: descText,
          quantity,
          pieceMeasure,
          isPieceMeasureLocked,
          unit: item.unit || "",
          unitWeight: fix(unitWeight, 3),
          unitPrice: fix(unitPrice, 2),
          pieceWeight: fix(pieceWeight, 3),
          totalWeight: fix(totalWeight, 3),
          price: fix(price, 2),
          totalPrice: fix(totalPrice, 2),
          unitWeightModifier: wtModifier,
          unitPriceModifier: item.unitPriceModifier || "1",
          xAccess: (code.startsWith("BUW") || code.startsWith("BUF")) ? xAccess : "",
          yAccess: (code.startsWith("BUW") || code.startsWith("BUF")) ? yAccess : "",
          avg: avg === "" ? "" : fix(avg, 3),
        };
      }),
    ];

    const reindexed = newData.map((i, index) => ({
      ...i,
      local_id: index + 1,
    }));

    return {
      ...prev,
      [key]: {
        ...prev[key],
        [activeBuildingId]: reindexed,
      },
    };
  });
};



  useEffect(() => {
   console.time('LoadMaterialCatalog');
   
   let obj = {
     queryName: "Get_ALL_Material",
   };
   
   ItemService.generateCustomerQueryHb(obj)
     .then((res) => {
       console.timeEnd('LoadMaterialCatalog');
       console.log('Material catalog size:', res?.data?.length);
       
       if (res?.data?.length) {
         setmaterialCatlog(Array.isArray(res.data) ? res.data : []);
       } else {
         setmaterialCatlog([]);
       }
     })
     .catch((error) => {
       console.error("Failed to fetch material details:", error);
       toast.error("Failed to fetch material details!");
       setmaterialCatlog([]);
     });
 }, []);

    const componentBlocks = {
    builtUpMembers: {
      icon: "BU",
      title: "Built-Up Members",
      subtitle: "Built-Up Members details",
      fields: [
        { label: "Job No (Built-Up Members)", name: "jobNoBuiltUpMembers" },
      ],
    },
    leftSideWall: {
      icon: "LSW",
      title: "Left Side Wall",
      subtitle: "Left Side Wall details",
      fields: [{ label: "Job No (Left Side Wall)", name: "jobNoLeftSideWall" }],
    },
    rightSideWall: {
      icon: "RSW",
      title: "Right Side Wall",
      subtitle: "Right Side Wall details",
      fields: [
        { label: "Job No (Right Side Wall)", name: "jobNoRightSideWall" },
      ],
    },
    frontEndWall: {
      icon: "FEW",
      title: "Front End Wall",
      subtitle: "Front End Wall details",
      fields: [{ label: "Job No (Front End Wall)", name: "jobNoFrontEndWall" }],
    },
    backEndWall: {
      icon: "BEW",
      title: "Back End Wall",
      subtitle: "Back End Wall details",
      fields: [{ label: "Job No (Back End Wall)", name: "jobNoBackEndWall" }],
    },
    roof01: {
      icon: "R1",
      title: "Roof-01",
      subtitle: "Roof-01 details",
      fields: [{ label: "Job No (Roof-01)", name: "jobNoRoof01" }],
    },
    roof02: {
      icon: "R2",
      title: "Roof-02",
      subtitle: "Roof-02 details",
      fields: [{ label: "Job No (Roof-02)", name: "jobNoRoof02" }],
    },
    pipeStrut: {
      icon: "PS",
      title: "Pipe Strut",
      subtitle: "Pipe Strut details",
      fields: [{ label: "Job No (Pipe Strut)", name: "jobNoPipeStrut" }],
    },
    pipeBracing: {
      icon: "PB",
      title: "Pipe Bracing",
      subtitle: "Pipe Bracing details",
      fields: [{ label: "Job No (Pipe Bracing)", name: "jobNoPipeBracing" }],
    },
    hr: {
      icon: "HRM",
      title: "HR",
      subtitle: "HR details",
      fields: [{ label: "Job No (HR)", name: "jobNoHr" }],
    },
    portalBracing: {
      icon: "PBM",
      title: "Portal Bracing",
      subtitle: "Portal Bracing details",
      fields: [
        { label: "Job No (Portal Bracing)", name: "jobNoPortalBracing" },
      ],
    },
    leanTo: {
      icon: "LT",
      title: "Lean-To",
      subtitle: "Lean-To details",
      fields: [{ label: "Job No (Lean-To)", name: "jobNoLeanTo" }],
    },
    canopy: {
      icon: "CP",
      title: "Canopy",
      subtitle: "Canopy details",
      fields: [{ label: "Job No (Canopy)", name: "jobNoCanopy" }],
    },
    frameOpening: {
      icon: "FO",
      title: "Frame Opening",
      subtitle: "Frame Opening details",
      fields: [{ label: "Job No (Frame Opening)", name: "jobNoFrameOpening" }],
    },
    partitionWall: {
      icon: "PW",
      title: "Partition Wall",
      subtitle: "Partition Wall details",
      fields: [
        { label: "Job No (Partition Wall)", name: "jobNoPartitionWall" },
      ],
    },
    ridgeVentilator: {
      icon: "RV",
      title: "Ridge Ventilator",
      subtitle: "Ridge Ventilator details",
      fields: [
        { label: "Job No (Ridge Ventilator)", name: "jobNoRidgeVentilator" },
      ],
    },
    turboFans: {
      icon: "TF",
      title: "Turbo Fans",
      subtitle: "Turbo Fans details",
      fields: [{ label: "Job No (Turbo Fans)", name: "jobNoTurboFans" }],
    },
    cageLadder: {
      icon: "CL",
      title: "Cage Ladder",
      subtitle: "Cage Ladder details",
      fields: [{ label: "Job No (Cage Ladder)", name: "jobNoCageLadder" }],
    },
    craneBeam: {
      icon: "CB",
      title: "Crane Beam",
      subtitle: "Crane Beam details",
      fields: [{ label: "Job No (Crane Beam)", name: "jobNoCraneBeam" }],
    },
    mezzanine: {
      icon: "MZ",
      title: "Mezzanine",
      subtitle: "Mezzanine details",
      fields: [{ label: "Job No (Mezzanine)", name: "jobNoMezzanine" }],
    },
    fascia: {
      icon: "FA",
      title: "Fascia",
      subtitle: "Fascia details",
      fields: [{ label: "Job No (Fascia)", name: "jobNoFascia" }],
    },
    louvers: {
      icon: "LO",
      title: "Louvers",
      subtitle: "Louvers details",
      fields: [{ label: "Job No (Louvers)", name: "jobNoLouvers" }],
    },
    structuralLouver: {
      icon: "SL",
      title: "Structural Louver",
      subtitle: "Structural Louver details",
      fields: [
        { label: "Job No (Structural Louver)", name: "jobNoStructuralLouver" },
      ],
    },
    industrialLouver: {
      icon: "IL",
      title: "Industrial Louver",
      subtitle: "Industrial Louver details",
      fields: [
        { label: "Job No (Industrial Louver)", name: "jobNoIndustrialLouver" },
      ],
    },
    staircase: {
      icon: "SC",
      title: "Staircase",
      subtitle: "Staircase details",
      fields: [{ label: "Job No (Staircase)", name: "jobNoStaircase" }],
    },
    handrail: {
      icon: "HRL",
      title: "Handrail",
      subtitle: "Handrail details",
      fields: [{ label: "Job No (Handrail)", name: "jobNoHandrail" }],
    },
    hotRolled: {
      icon: "HR",
      title: "Hot Rolled",
      subtitle: "Hot Rolled details",
      fields: [
        { label: "Job No (Hot Rolled)", name: "jobNoHotRolled" },
        { label: "Quote No (Hot Rolled)", name: "quoteNoHotRolled" },
      ],
    },
    others: {
      icon: "OT",
      title: "Others",
      subtitle: "Other details",
      fields: [
        { label: "Job No (Others)", name: "jobNoOthers" },
        { label: "Quote No (Others)", name: "quoteNoOthers" },
      ],
    },
  };

    const initialBlockData = Object.keys(componentBlocks)?.reduce((acc, key) => {
    acc[key] = {};
    // Initialize data for each building
    buildings?.forEach((building) => {
      acc[key][building.id] = [];
    });
    return acc;
  }, {});

  const [componentBlockData, setComponentBlockData] =
    useState(initialBlockData);


//  REPLACE getProductDetailsCol
const getProductDetailsCol = useCallback((identifier, isComponent = false, data = []) => {
    const isOthersBlock = identifier === "others";
const othersDescriptionColumn = {
  name: "Other Description",
  cell: (row) =>
    row.code === "TOTAL" ? "--" : (
      <InputField
        className="inputBox mt-1"
        name="otherDescription"
        placeholder="Enter description"
        value={row.otherDescription || ""}
        onChange={(e) => {
          const value = e.target.value;

          if (isComponent) {
            setComponentBlockData((prev) => {
              const buildingData =
                prev[identifier]?.[activeBuildingId] || [];

              return {
                ...prev,
                [identifier]: {
                  ...prev[identifier],
                  [activeBuildingId]: buildingData.map((r) =>
                    r.local_id === row.local_id
                      ? { ...r, otherDescription: value }
                      : r
                  ),
                },
              };
            });
          } else {
            setBlocks((prev) =>
              prev.map((b, i) =>
                i === identifier
                  ? {
                      ...b,
                      getProductDetailsData:
                        b.getProductDetailsData.map((r) =>
                          r.local_id === row.local_id
                            ? { ...r, otherDescription: value }
                            : r
                        ),
                    }
                  : b
              )
            );
          }
        }}
      />
    ),
  width: "220px",
};
  const columns = [
    {
      name: "Sl.No",
      selector: (row) => row.local_id || "--",
      cell: (row) => (row.code === "TOTAL" ? "" : <>{row.local_id}.</>),
      width: "80px",
    },
   {
     name: "Material Code & Description",
     selector: (row) => row.code,
     cell: (row) => {
       const cleanNumber = (val) => {
         const str = String(val ?? "");
         const num = parseFloat(str.replace(/[^0-9.]/g, ""));
         return isNaN(num) ? "" : num;
       };
   
       const handleDepthChange = (field, value) => {
         const numericValue = cleanNumber(value);
         const event = { target: { name: field, value: numericValue } };
         if (isComponent)
           handleInputChangeForComponent(identifier, row.local_id, event, "Number", true);
         else
           handleInputChange(identifier, row.local_id, event, "Number", true);
       };
   
       const code = row.code?.toUpperCase() || "";
       const isBUF = code.startsWith("BUF");
       const isBUW = code.startsWith("BUW") && !code.startsWith("BUWT");
       const showDepthFields = !row.isFromMto && (isBUF || isBUW);
       const hideFinalDepth = isBUF;
   
       return (
         <div style={{ display: "flex", flexDirection: "column", gap: "5px", padding: "4px 0" }}>
           {/* Material Code Input */}
           <InputField
             type="text"
             className="inputBox mt-1"
             name="code"
             placeholder="Enter Material Code"
             value={row.code || ""}
             onChange={(e) => {
               const enteredCode = e.target.value.toUpperCase().trim();
               if (isComponent) {
                 setComponentBlockData((prev) => {
                   const bData = prev[identifier]?.[activeBuildingId] || [];
                   return {
                     ...prev,
                     [identifier]: {
                       ...prev[identifier],
                       [activeBuildingId]: bData.map((r) =>
                         r.local_id === row.local_id ? { ...r, code: enteredCode } : r
                       ),
                     },
                   };
                 });
               } else {
                 setBlocks((prev) =>
                   prev.map((b, i) =>
                     i === identifier
                       ? {
                           ...b,
                           getProductDetailsData: b.getProductDetailsData.map((r) =>
                             r.local_id === row.local_id ? { ...r, code: enteredCode } : r
                           ),
                         }
                       : b
                   )
                 );
               }
             }}
             onKeyDown={(e) => {
               if (e.key === 'Enter') {
                 e.preventDefault();
                 const enteredCode = e.target.value.toUpperCase().trim();
                 const material = Array.isArray(materialCatlog)
                   ? materialCatlog.find((item) => item.code?.toUpperCase() === enteredCode)
                   : null;
                 if (isComponent)
                   handleMaterialCodeChangeForComponent(identifier, row.local_id, enteredCode, material);
                 else
                   handleMaterialCodeChange(identifier, row.local_id, enteredCode, material);
               }
             }}
             onBlur={(e) => {
               const enteredCode = e.target.value.toUpperCase().trim();
               const material = Array.isArray(materialCatlog)
                 ? materialCatlog.find((item) => item.code?.toUpperCase() === enteredCode)
                 : null;
               if (isComponent)
                 handleMaterialCodeChangeForComponent(identifier, row.local_id, enteredCode, material);
               else
                 handleMaterialCodeChange(identifier, row.local_id, enteredCode, material);
             }}
             style={{
               width: "180px",
               fontSize: "13px",
               padding: "4px",
               borderRadius: "4px",
               border: "1px solid #ccc",
             }}
           />
   
           {/* 🔹 FIXED: Description & Width in the SAME LINE */}
           <div style={{ fontSize: "13px", color: "#444", lineHeight: "1.3", display: "flex", alignItems: "center", flexWrap: "wrap", gap: "6px" }}>
             <span>{row?.description || row?.materialDescription || "--"}</span>
             
             {row.width > 0 && (
               <span style={{ 
                 fontSize: "12px", 
                 color: "black", 
                 // fontWeight: "700",
                 // backgroundColor: "#eff6ff",
                 padding: "0px 4px",
                 borderRadius: "3px",
                 // border: "1px solid #dbeafe"
               }}>
                 Width: {row.width}mm
               </span>
             )}
           </div>
   
           {/* Depth Fields (Initial, Final, Avg) */}
           {showDepthFields && (
             <div style={{ display: "flex", alignItems: "center", gap: "5px", fontSize: "13px", color: "#333", marginTop: "1px", flexWrap: "wrap" }}>
               <span>(Initial:</span>
               <span
                 contentEditable
                 suppressContentEditableWarning
                 style={{ display: "inline-block", minWidth: "30px", borderBottom: "1px dotted red", outline: "none" }}
                 onBlur={(e) => handleDepthChange("xAccess", e.currentTarget.textContent.trim())}
               >
                 {row.xAccess || ""}
               </span>
               {!hideFinalDepth && (
                 <>
                   <span>, Final:</span>
                   <span
                     contentEditable
                     suppressContentEditableWarning
                     style={{ display: "inline-block", minWidth: "30px", borderBottom: "1px dotted red", outline: "none" }}
                     onBlur={(e) => handleDepthChange("yAccess", e.currentTarget.textContent.trim())}
                   >
                     {row.yAccess || ""}
                   </span>
                 </>
               )}
               <span>Avg:</span>
               <span style={{ minWidth: "30px", borderBottom: "1px dotted #888" }}>{row.avg || ""}</span>
             </div>
           )}
         </div>
       );
     },
     width: "320px",
     wrap: true,
   },
        ...(isOthersBlock ? [othersDescriptionColumn] : []),

    {
      name: "Quantity",
      cell: (row) => {
        const error = validationErrors?.[identifier]?.[row.local_id] || "";
        return row.code === "TOTAL" ? "--" : (
          <div>
            <InputField
              className="inputBox mt-1"
              name="quantity"
              step={1}
              value={row.quantity ?? ""}
              onChange={(e) => {
                const { name, value } = e.target;
                const cleanValue = value.replace(/[^0-9]/g, "");
                if (isComponent) {
                  setComponentBlockData((prev) => {
                    const buildingData = prev[identifier]?.[activeBuildingId] || [];
                    const rowIndex = buildingData.findIndex(r => r.local_id === row.local_id);
                    if (rowIndex === -1) return prev;
                    const newData = [...buildingData];
                    newData[rowIndex] = { ...newData[rowIndex], [name]: cleanValue };
                    return { ...prev, [identifier]: { ...prev[identifier], [activeBuildingId]: newData } };
                  });
                } else {
                  setBlocks((prev) => prev.map((b, i) => i === identifier ? {
                    ...b, getProductDetailsData: b.getProductDetailsData.map((r) =>
                      r.local_id === row.local_id ? { ...r, [name]: cleanValue } : r
                    )
                  } : b));
                }
              }}
              onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); e.target.blur(); } }}
              onBlur={(e) => {
                if (isComponent) handleInputChangeForComponent(identifier, row.local_id, e, "Number", true);
                else handleInputChange(identifier, row.local_id, e, "Number", true);
                validateQtyAndPieceRow(identifier, row);
              }}
            />
            {error && <small style={{ color: "red" }}>{error}</small>}
          </div>
        );
      },
      width: "100px",
    },
    {
      name: "Piece Measure",
      cell: (row) => {
        const error = validationErrors?.[identifier]?.[row.local_id] || "";
        return row.code === "TOTAL" ? "--" : (
          <div style={{ width: "100%" }}>
            <InputField
              className="inputBox mt-1"
              name="pieceMeasure"
              step={0.001}
              value={row.pieceMeasure ?? row.pieceMeasurement ?? ""}
              disabled={!!row.isPieceMeasureLocked}
              style={row.isPieceMeasureLocked ? { backgroundColor: "#f0f0f0", cursor: "not-allowed" } : {}}
              onChange={(e) => {
                const { name, value } = e.target;
                const processedValue = value.replace(/^(\d*)(\.(\d{0,3})?)?$/, (m, intPart, decPart) =>
                  decPart ? (intPart || "0") + decPart : intPart
                );
                if (isComponent) {
                  setComponentBlockData((prev) => {
                    const buildingData = prev[identifier]?.[activeBuildingId] || [];
                    return { ...prev, [identifier]: { ...prev[identifier], [activeBuildingId]: buildingData.map((r) =>
                      r.local_id === row.local_id ? { ...r, [name]: processedValue } : r
                    )}};
                  });
                } else {
                  setBlocks((prev) => prev.map((b, i) => i === identifier ? {
                    ...b, getProductDetailsData: b.getProductDetailsData.map((r) =>
                      r.local_id === row.local_id ? { ...r, [name]: processedValue } : r
                    )
                  } : b));
                }
              }}
              onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); e.target.blur(); } }}
              onBlur={(e) => {
                if (isComponent) handleInputChangeForComponent(identifier, row.local_id, e, "Number", true);
                else handleInputChange(identifier, row.local_id, e, "Number", true);
                validateQtyAndPieceRow(identifier, row);
              }}
            />
            {error && <small style={{ color: "red", display: "block", marginTop: "2px" }}>{error}</small>}
          </div>
        );
      },
      width: "100px",
    },
    // ... rest of your columns (Unit, Weight, Unit Price, etc. - keep them as they are)
    {
      name: "Unit",
      cell: (row) =>
        row.code === "TOTAL" ? "--" : (
          <div><p style={{ fontWeight: "bold", margin: 0 }}>{row.unit || "--"}</p></div>
        ),
      width: "100px",
    },
    // {
    //   name: "Weight",
    //   cell: (row) =>
    //     row.code === "TOTAL" ? "--" : (
    //       <div><p style={{ margin: 0 }}>{row.unitWeight ? Number(row.unitWeight).toFixed(3) : "--"}</p></div>
    //     ),
    //   width: "100px",
    // },
       {
  name: "Weight",
  cell: (row) =>
    row.code === "TOTAL" ? "--" : (
      <div>
        <p style={{ margin: 0 }}>
          {Number(row.unitWeight) === 0
            ? Number(row.pieceMeasure || 0).toFixed(3)
            : Number(row.unitWeight).toFixed(3)}
        </p>
      </div>
    ),
  width: "100px",
},
    {
      name: "Unit Price",
      cell: (row) =>
        row.code === "TOTAL" ? "--" : (
          <InputField
            className="inputBox mt-1"
            name="unitPrice"
            value={row.unitPrice || ""}
            onChange={(e) =>
              isComponent
                ? handleInputChangeForComponent(identifier, row.local_id, e, "Number")
                : handleInputChange(identifier, row.local_id, e, "Number")
            }
            disabled={true}
          />
        ),
      width: "100px",
    },
    {
      name: "Piece Weight",
      selector: (row) => row.code === "TOTAL" ? "--" : row.pieceWeight || "--",
      width: "100px",
    },
    {
      name: "Total Weight",
      selector: (row) => row.totalWeight?.toFixed?.(3) || row.totalWeight || "--",
      cell: (row) =>
        row.code === "TOTAL" ? (
          <div style={{ minWidth: "160px", fontWeight: "bold", textAlign: "center", whiteSpace: "nowrap", overflow: "visible" }}>
            {row.totalWeight}
          </div>
        ) : (row.totalWeight || "--"),
      width: "160px",
    },
    {
      name: "Price",
      selector: (row) => row.code === "TOTAL" ? "--" : row.price || "--",
      width: "100px",
    },
    {
      name: "Total Price",
      selector: (row) => row.totalPrice || "--",
      cell: (row) =>
        row.code === "TOTAL" ? (
          <div style={{ minWidth: "180px", fontWeight: "bold", textAlign: "center", whiteSpace: "nowrap", overflow: "visible" }}>
            {row.totalPrice}
          </div>
        ) : (row.totalPrice || "--"),
      width: "180px",
    },
    {
      name: "Wt. Modifier",
      cell: (row) =>
        row.code === "TOTAL" ? "--" : (
          <InputField
            className="inputBox mt-1"
            name="unitWeightModifier"
            value={row.unitWeightModifier || ""}
            onChange={(e) =>
              isComponent
                ? handleInputChangeForComponent(identifier, row.local_id, e, "Number")
                : handleInputChange(identifier, row.local_id, e, "Number")
            }
          />
        ),
      width: "100px",
    },
    {
      name: "Price Modifier",
      cell: (row) =>
        row.code === "TOTAL" ? "--" : (
          <InputField
            className="inputBox mt-1"
            name="unitPriceModifier"
            value={row.unitPriceModifier || ""}
            onChange={(e) =>
              isComponent
                ? handleInputChangeForComponent(identifier, row.local_id, e, "Number")
                : handleInputChange(identifier, row.local_id, e, "Number")
            }
          />
        ),
      width: "100px",
    },
    {
      name: "Surface/Paint",
      selector: (row) => row.surfacePaintArea || "--",
      width: "100px",
    },
    {
      name: "Delete",
      cell: (row) =>
        row.code === "TOTAL" ? "--" : (
          <button
            onClick={() =>
              isComponent
                ? removeProductDetailsForComponent(identifier, row.local_id)
                : removeProductDetails(identifier, row.local_id)
            }
          >
            <i className="bi bi-trash text-danger fs-4" />
          </button>
        ),
      width: "100px",
    },
    {
      name: "Add",
      cell: (row) =>
        row.code === "TOTAL" ? "--" : (
          <button onClick={() => addEmptyRowToComponent(identifier, row.local_id)}>
            <i className="bi bi-plus-circle fs-4" />
          </button>
        ),
      width: "80px",
    },
  ];

  return columns;
  // eslint-disable-next-line
}, [disabled, validationErrors, materialCatlog, activeBuildingId, handleInputChangeForComponent, handleMaterialCodeChangeForComponent, setComponentBlockData, setBlocks]);
  const recalcDerived = (row) => {
    const totalWeight = num(row.pieceWeight) * num(row.pieceMeasurement);
    const price = num(row.pieceWeight) * num(row.unitPrice);
    const totalPrice = totalWeight * num(row.unitPrice);
    return {
      ...row,
      totalWeight: totalWeight ? Number(totalWeight.toFixed(2)) : "",
      price: price ? Number(price.toFixed(2)) : "",
      totalPrice: totalPrice ? Number(totalPrice.toFixed(2)) : "",
    };
  };

  const [formInputs, setFormInputs] = useState({});

  const [buildingCount, setBuildingCount] = useState(1);


  const [getOverallBuildingArea, setOverallBuildingArea] = useState();

  useEffect(() => {
    const saved = JSON.parse(localStorage.getItem("selectedComponents")) || {};
    const apiData = estimationData || {};

    const merged = { ...apiData, ...saved };
    setFormInputs(merged);

    setBuildings(estimationData?.buildings);
    setBuildingCount(estimationData?.buildingCount);
    setActiveBuildingId(estimationData?.activeBuildingId);
    setOverallBuildingArea(estimationData?.getOverallBuildingArea);

    // optional: reinitialize or update block data
    setComponentBlockData(initialBlockData);

    const initialVisible = Object.keys(componentBlocks)?.reduce((acc, key) => {
      acc[key] = !!merged[key];
      return acc;
    }, {});
    setVisibleBlocks(initialVisible);
    // eslint-disable-next-line
  }, [estimationData]);

  const addEmptyRowToComponent = (key, afterId = null) => {
    setComponentBlockData((prev) => {
      const currentData = prev[key]?.[activeBuildingId] || [];
      const newLocalId =
        currentData.length > 0
          ? Math.max(...currentData.map((item) => item.local_id)) + 1
          : 1;

      const newRow = {
        local_id: newLocalId,
        code: "",
        description: "",
        unit: "M",
        unitWeight: "",
        pieceWeight: "",
        unitPrice: "",
        totalWeight: "",
        price: "",
        totalPrice: "",
        unitWeightModifier: 1,
        unitPriceModifier: 1,
        surfacePaintArea: "--",
        quantity: "",
        pieceMeasure: "",
        xAccess: "",
        yAccess: "",
        avg: "",
      };

      let newData;
      if (afterId) {
        const index = currentData.findIndex(
          (item) => item.local_id === afterId
        );
        newData = [...currentData];
        newData.splice(index + 1, 0, newRow);
      } else {
        newData = [...currentData, newRow];
      }

      // Reindex local_id
      newData = newData.map((item, index) => ({
        ...item,
        local_id: index + 1,
      }));

      return {
        ...prev,
        [key]: {
          ...prev[key],
          [activeBuildingId]: newData,
        },
      };
    });
  };

  const addProductDetails = (identifier, isComponent = false) => {
    if (isComponent) {
      setActiveComponentKey(identifier);
      setActiveBlockIndex(null);
    } else {
      setActiveBlockIndex(identifier);
      setActiveComponentKey(null);
    }
    setModalShow(true);
  };

  const hideModal = () => {
    setModalShow(false);
    setActiveBlockIndex(null);
    setActiveComponentKey(null);
  };

  useEffect(() => {
    if (estimationData && Object.keys(estimationData).length > 0) {
      setComponentBlockData(
        estimationData?.componentBlocks || initialBlockData
      );
    }
    // eslint-disable-next-line
  }, [estimationData]);
  // upload excel function
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [parsedData, setParsedData] = useState([]);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [showDataModal, setShowDataModal] = useState(false);
  // eslint-disable-next-line
  const [mtoData, setMtodata] = useState([]);

    const handleSaveUpload = async (file, camelCaseTitles = []) => {
    const loadingToast = toast.loading(`Uploading ${parsedData.length} items...`);
    
    try {
      // Process all data at once
      const allPayloads = parsedData.map((item, index) => {
        const quantity = parseFloat(item.qty) || 0;
        const pieceMeasure = parseFloat(item.length) || 0;
        let unitWeight = parseFloat(item.unitWeight) || 0;
        const unitPrice = parseFloat(item.unitPrice) || 0;
        const code = (item.mtoMaterialCode || "").toUpperCase();
        const avg = parseFloat(item.avg) || 0;
        const width = parseFloat(item.width) || 0; 

  
        let pieceWeight = 0;
        if (code.startsWith("BUF") || code.startsWith("BUW")) {
          pieceWeight = avg > 0 ? avg * unitWeight * pieceMeasure : pieceMeasure * unitWeight;
        } else {
          pieceWeight = pieceMeasure * unitWeight;
        }
  
        const price = pieceWeight * unitPrice;
        const totalPrice = price * quantity;
        const fix = (v, dec) => (isNaN(v) || !v ? 0 : Number(v).toFixed(dec));
  
        return {
          local_id: index + 1,
          code,
          description: item.finalItem || "",
          mtoMaterialGroup: item.mtoMaterialGroup || "",
          section: item.section || "",
          quantity,
          pieceMeasure,
          unitWeight,
          totalWeight: parseFloat(item.totalWeight) || 0,
          unit: "M",
          unitPrice,
          price: fix(price, 2),
          totalPrice: fix(totalPrice, 2),
          unitWeightModifier: 1,
          unitPriceModifier: 1,
          surfacePaintArea: "--",
          xAccess: "",
          yAccess: "",
          avg,
          width,
          isFromMto: true,
        };
      });
  
      // Single state update for all components
      setComponentBlockData((prev) => {
        const updated = { ...prev };
        camelCaseTitles.forEach((key) => {
          const existing = updated[key]?.[activeBuildingId] || [];
          const startId = existing.length + 1;
          updated[key] = {
            ...updated[key],
            [activeBuildingId]: [
              ...existing,
              ...allPayloads.map((p, i) => ({ ...p, local_id: startId + i }))
            ],
          };
        });
        return updated;
      });
  
      toast.dismiss(loadingToast);
      toast.success('MTO uploaded successfully!');
      setShowDataModal(false);
    } catch (error) {
      toast.dismiss(loadingToast);
      toast.error('Upload failed!');
      console.error(error);
    }
  };

  const handleUploadComplete = async ({ jsonData, file }) => {
    const mappedData = jsonData.map((row) => {
      const section = row["Section"] || "";
      const items = row["Items"] || "";

      const normalized = Object.fromEntries(
        Object.entries(row).map(([key, value]) => [
          key.trim().toLowerCase(),
          value,
        ])
      );

      const match = section.match(/\d+$/);
      const num = match ? match[0] : "";

      let prefix = "";
      let mtoMaterialGroup = "";

      if (items.toLowerCase().includes("web")) {
        prefix = "BUW";
        mtoMaterialGroup = "BUW";
      } else if (items.toLowerCase().includes("flange")) {
        prefix = "BUF";
        mtoMaterialGroup = "BUF";
      }

      const mtoMaterialCode = prefix && num ? `${prefix}${num}` : "";
      const finalItem = prefix && num ? `${items} (${mtoMaterialCode})` : items;

      // 🛑 NEW LOGIC: Look up Unit Price from DB/Material Catalog
      let dbUnitPrice = 0;

      if (mtoMaterialCode && Array.isArray(materialCatlog)) {
        const material = materialCatlog.find(
          (item) =>
            item.code &&
            item.code.toUpperCase() === mtoMaterialCode.toUpperCase()
        );
        // Use the Unit Price from the catalog if found
        dbUnitPrice = parseFloat(material?.unitPrice) || 0;
      }

      return {
        slNo: row["Sl. No."] || "",
        items,
        finalItem,
        mtoMaterialCode,
        mtoMaterialGroup,
        section,
        width: row["Width (mm)"] || 0,
        length: row["Length (mm)"] || 0,
        qty: row["Qty (#)"] || 0,
        unitWeight: row["Unit Weight (Kg)"] || 0,
        totalWeight: row["Total Weight (Kg)"] || 0,

        // 🛑 Use the DB/Catalog Unit Price
        unitPrice: dbUnitPrice,

        avg: normalized["avg"] || 0,
      };
    });

    setParsedData(mappedData);
    setUploadedFile(file);
    setShowDataModal(true);
    setMtodata(mappedData);
  };

  const MTOColumns = [
    { name: "Sl. No.", selector: (row) => row.slNo, width: "100px" },
    { name: "Items", selector: (row) => row.items, width: "240px" },
    {
      name: "Material Code",
      selector: (row) => row.mtoMaterialCode,
      width: "160px",
    },
    {
      name: "Material Group",
      selector: (row) => row.mtoMaterialGroup,
      width: "160px",
    },
    { name: "Section", selector: (row) => row.section, width: "120px" },
    { name: "Width (mm)", selector: (row) => row.width, width: "120px" },
    { name: "Length (mm)", selector: (row) => row.length, width: "120px" },
    { name: "Qty (#)", selector: (row) => row.qty, width: "100px" },
    {
      name: "Unit Weight (Kg)",
      selector: (row) => row.unitWeight,
      width: "150px",
    },
    {
      name: "Total Weight (Kg)",
      selector: (row) => row.totalWeight,
      width: "150px",
    },
    {
      name: "Unit Price",
      selector: (row) => row.unitPrice,
      width: "150px",
    },
    {
      name: "Avg",
      selector: (row) => row.avg,
      width: "150px",
    },
  ];
  //============================setbuilding or multip buildings ===============================
  //additional component
  const handleBuildingCheckboxChange = (buildingId, componentName, checked) => {
    setBuildings((prevBuildings) =>
      prevBuildings.map((building) =>
        building.id === buildingId
          ? {
              ...building,
              additionalComponents: {
                ...building.additionalComponents,
                [componentName]: checked,
              },
            }
          : building
      )
    );
  };

  const getCurrentBlockData = useCallback((key) => {
    const data = componentBlockData[key]?.[activeBuildingId] ?? [];
    
    let overallTotalWeight = 0;
    let overallTotalPrice = 0;
  
    data.forEach((item) => {
      if (item.code !== "TOTAL") {
        overallTotalWeight += parseFloat(item.totalWeight || 0);
        overallTotalPrice += parseFloat(item.totalPrice || 0);
      }
    });
  
    const summaryRow = {
      slNo: "",
      code: "TOTAL",
      description: "",
      unit: "",
      unitWeight: "",
      quantity: "",
      totalWeight: "Total Weight: " + overallTotalWeight.toFixed(3),
      unitPrice: "",
      totalPrice: "Total Price: " + overallTotalPrice.toFixed(3),
    };
  
    return [...data, summaryRow];
  }, [componentBlockData, activeBuildingId]);
  /* handle building input chnages */

  // eslint-disable-next-line
  const handleBuildingInputChange = (e, buildingId) => {
    const { name, value } = e.target;

    setBuildings((prevBuildings) =>
      prevBuildings.map((building) =>
        building.id === buildingId ? { ...building, [name]: value } : building
      )
    );
  };
  // Use only active building data for totals
  const allRows = Object.keys(componentBlockData || {}).flatMap((key) => {
    const buildingData = componentBlockData[key]?.[activeBuildingId];
    return Array.isArray(buildingData) ? buildingData : [];
  });

  const overallTotalWeight = allRows?.reduce(
    (acc, row) => acc + (parseFloat(row?.totalWeight) || 0),
    0
  );
  const overallTotalPrice = allRows?.reduce(
    (acc, row) => acc + (parseFloat(row?.totalPrice) || 0),
    0
  );
  //
  const buildingRows = Object.keys(componentBlockData || {}).reduce(
    (acc, blockKey) => {
      const blockObj = componentBlockData[blockKey];

      Object.keys(blockObj || {}).forEach((buildingId) => {
        if (!acc[buildingId]) acc[buildingId] = [];
        const rows = Array.isArray(blockObj[buildingId])
          ? blockObj[buildingId]
          : [];
        acc[buildingId].push(...rows);
      });

      return acc;
    },
    {}
  );
  const buildingTotals = Object.keys(buildingRows).reduce((acc, buildingId) => {
    const rows = buildingRows[buildingId];

    const totalWeight = rows.reduce(
      (sum, row) => sum + (parseFloat(row.totalWeight) || 0),
      0
    );

    const totalPrice = rows.reduce(
      (sum, row) => sum + (parseFloat(row.totalPrice) || 0),
      0
    );

    acc[buildingId] = { totalWeight, totalPrice };
    return acc;
  }, {});
  const grandTotals = Object.keys(buildingTotals).reduce(
    (acc, buildingId) => {
      acc.totalWeight += buildingTotals[buildingId].totalWeight || 0;
      acc.totalPrice += buildingTotals[buildingId].totalPrice || 0;
      return acc;
    },
    { totalWeight: 0, totalPrice: 0 }
  );
  //Remarks
  const handleRemarks = (content, buildingId) => {
    setBuildings((prevBuildings) =>
      prevBuildings.map((building) =>
        building.id === buildingId
          ? { ...building, remarksEstimationCreation: content }
          : building
      )
    );
  };
  const toggleCardVisibility10 = (buildingId) => {
    setBuildings((prev) =>
      prev.map((building) =>
        building.id === buildingId
          ? { ...building, isCardVisible10: !building.isCardVisible10 }
          : building
      )
    );
  };
  //handle input change
  const handleBuildingFieldChange = (buildingId, fieldName, value) => {
    setBuildings((prevBuildings) =>
      prevBuildings.map((building) =>
        building.id === buildingId
          ? { ...building, [fieldName]: value }
          : building
      )
    );
  };

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <h2 className="mainTitle">Estimate Creation</h2>
            <p className="subText">Estimate Creation</p>
            <hr />
            {/* Estimate details block  */}
            <div className="accordion mt-3 mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible2
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility2}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">ED</span>
                    </Col>

                    <Col xs={4} md={4} lg={4}>
                      <span className="headerTitle">Estimate details</span>
                      <span className="subHeaderTitle">Estimate details</span>
                    </Col>
                  </Row>
                </h2>
                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible2 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        md={6}
                        lg={3}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          type="date"
                          className="inputBox"
                          label="Date"
                          name="transactionDate"
                          value={formInputs?.transactionDate}
                          // onChange={handleFormInputChange}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={3}
                        className="commLeftRightPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Client Name"
                          name="clientName"
                          id="clientName"
                          // value={formInputs?.[0]?.clientName || ""}
                          value={formInputs?.clientName}
                          // onChange={handleFormInputChange}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={3}
                        className="commLeftRightPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Company Name"
                          name="companyName"
                          id="companyName"
                          value={formInputs?.companyName}
                          // onChange={handleFormInputChange}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={3}
                        className="commLeftRightPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Building name"
                          name="buildingName"
                          id="buildingName"
                          value={formInputs?.buildingName}
                          // onChange={handleFormInputChange}
                          disabled={true}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={6}
                        lg={3}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          type="text"
                          className="inputBox"
                          label="Sales Person Name"
                          name="salesOfficerName"
                          value={formInputs?.salesOfficerName}
                          // onChange={handleFormInputChange}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={3}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          type="text"
                          className="inputBox"
                          label="Location"
                          name="location"
                          value={formInputs?.location}
                          // onChange={handleFormInputChange}
                          disabled={true}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={6}
                        lg={3}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          type="text"
                          className="inputBox"
                          label="Remark"
                          name="remarks"
                          value={formInputs?.remarks}
                          // onChange={handleFormInputChange}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={3}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          type="text"
                          className="inputBox"
                          label="Time Line (Days)"
                          name="timeLine"
                          value={formInputs?.timeLine}
                          // onChange={handleFormInputChange}
                          disabled
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={6}
                        lg={3}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          type="date"
                          className="inputBox"
                          label="Estimate Start Date"
                          name="estimateStartdate"
                          value={formInputs?.estimateStartdate}
                          // onChange={(e) => {
                          //   handleFormInputChange(e);
                          //   calculateTimeline(
                          //     e.target.value,
                          //     formInputs?.estimateEndDate
                          //   );
                          // }}
                          min={2000}
                          disabled={true}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={6}
                        lg={3}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          type="date"
                          className="inputBox"
                          label="Estimate End Date"
                          name="estimateEndDate"
                          value={formInputs?.estimateEndDate}
                          // onChange={(e) => {
                          //   handleFormInputChange(e);
                          //   calculateTimeline(
                          //     formInputs?.estimateStartdate,
                          //     e.target.value
                          //   );
                          // }}
                          min={2000}
                          disabled={true}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={6}
                        lg={3}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          className="inputBox"
                          label="Status"
                          // data={statusOptions}
                          name="estimationStatus"
                          id="estimationStatus"
                          setValue={formInputs?.estimationStatus}
                          // getvalue={setDropdownData}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={3}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          className="inputBox"
                          // data={priorityOptions}
                          label="Building Complexity(Priority)"
                          name="priority"
                          id="priority"
                          setValue={formInputs?.priority}
                          // getvalue={setDropdownData}
                          disabled={true}
                        />
                      </Col>

                      {formInputs?.qtnReferenceNr && (
                        <Col
                          xs={12}
                          md={6}
                          lg={3}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Quote No"
                            name="qtnReferenceNr"
                            value={formInputs?.qtnReferenceNr || ""}
                            // onChange={handleFormInputChange}
                            disabled={true}
                          />
                        </Col>
                      )}
                      {formInputs?.jobReferenceNr && (
                        <Col
                          xs={12}
                          md={6}
                          lg={3}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Job No"
                            name="jobReferenceNr"
                            value={formInputs?.jobReferenceNr || ""}
                            // onChange={handleFormInputChange}
                            disabled={true}
                          />
                        </Col>
                      )}

                      {formInputs?.status === "Hold" && (
                        <Col
                          xs={12}
                          md={6}
                          lg={3}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            type="text"
                            className="inputBox"
                            label="Remark (Estimation)"
                            name="remarkestimation"
                            value={formInputs?.remarkestimation}
                            // onChange={handleFormInputChange}
                          />
                        </Col>
                      )}
                      <Col
                        xs={12}
                        md={6}
                        lg={3}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Revision"
                          name="version"
                          id="version"
                          value={formInputs?.version}
                          // onChange={handleFormInputChange}
                          disabled={true}
                        />
                      </Col>
                      {/* <Col
                        xs={12}
                        md={6}
                        lg={3}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Tonnage"
                          name="estTonnage"
                          id="estTonnage"
                          value={formInputs?.estTonnage}
                          // onChange={handleFormInputChange}
                          disabled={true}
                        />
                      </Col> */}

                      <Col
                        xs={12}
                        md={6}
                        lg={3}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Tonnage"
                          name="estTonnage"
                          id="estTonnage"
                          value={grandTotals?.totalWeight}
                          // onChange={handleFormInputChange}
                          disabled={true}
                          required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={3}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Estimate Cost"
                          name="estCost"
                          id="estCost"
                          value={grandTotals?.totalPrice}
                          // onChange={handleFormInputChange}
                          disabled={true}
                          required={true}
                        />
                      </Col>
                      
                      <Col
                        xs={12}
                        md={6}
                        lg={3}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Estimate Cost"
                          name="estCost"
                          // id={`estCost-${building.id}`}
                          value={
                            parseFloat(overallTotalPrice)?.toFixed(3) ?? ""
                          }
                          disabled={true}
                          // onChange={(e) =>
                          //   handleBuildingInputChange(e, building.id)
                          // }
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={3}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          type="number"
                          label="Number of Buildings"
                          className="inputBox"
                          value={buildingCount}
                          // onChange={(e) => {
                          //   let count = parseInt(e.target.value) || 1;
                          //   // Enforce the limit
                          //   count = Math.min(Math.max(1, count), 50);
                          //   setBuildingCount(count);
                          //   handleBuildingCountChange(count);
                          // }}
                          min="1"
                          max="10"
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={6}
                        className="commTopButtonRightLeftPadding"
                      >
                        <TextAreaField
                          label="Remarak"
                          className="inputBox"
                          name="estimationDetailsRemarks"
                          value={formInputs?.estimationDetailsRemarks}
                          onChange={handleFormInputChange}
                          disabled={disabled}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            <Row>
              <Col xs={12} md={12} lg={12}>
                <div className="card">
                  <div className="card-body pt-3">
                    <ul className="nav nav-tabs nav-tabs-bordered">
                      {buildings?.map((building, index) => (
                        <li key={building.id} className="nav-item">
                          <button
                            className={`nav-link ${
                              activeBuildingId === building.id ? "active" : ""
                            }`}
                            style={{
                              backgroundColor:
                                activeBuildingId === building.id
                                  ? "#007bff"
                                  : "transparent",
                              color:
                                activeBuildingId === building.id
                                  ? "#fff"
                                  : "#000",
                              borderRadius: "5px",
                              border: "none",
                              transition: "all 0.3s ease",
                              padding: "8px 16px",
                            }}
                            onClick={() => setActiveBuildingId(building.id)}
                          >
                            Building Estimation {index + 1}
                          </button>
                        </li>
                      ))}
                    </ul>

                    <div
                      className="tab-content pt-2"
                      style={{
                        overflowY: "auto",
                        // maxHeight: "70vh",
                      }}
                    >
                      {buildings?.map((building, index) => (
                        <div
                          key={building.id}
                          className={`tab-pane fade ${
                            activeBuildingId === building.id
                              ? "show active"
                              : ""
                          }`}
                        >
                          {/* Building Structure Details Accordion */}
                          <h5 class="bg-table-status bg-table-new-status ml-2 mt-3 p-3">
                            Building Specification {index + 1}{" "}
                          </h5>
                          <Row className="mb-2">
                            <Col xs={12} md={12} lg={12}>
                              <h5 className="mb-2 text-primary">
                                Structure Type
                              </h5>
                            </Col>
                            <Col
                              xs={12}
                              md={3}
                              lg={3}
                              className="commTopButtonRightLeftPadding ml-0"
                            >
                              <ComboboxField
                                className="inputBox"
                                label="Building Types"
                                placeholder=""
                                // data={buildingTypes}
                                name="buildingTypes"
                                code={`buildingTypesCode-${building?.id}`}
                                description="buildingTypesDesc"
                                setValue={building?.buildingTypes || ""}
                                // getvalue={setDropdownData}
                                disabled={true}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={3}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <ComboboxField
                                className="inputBox"
                                // data={buildingStrctures}
                                label="Building Structure"
                                name="buildingStructure"
                                code={`buildingStructureCode-${building?.id}`}
                                description="buildingStructureDesc"
                                setValue={building?.buildingStructure || ""}
                                // getvalue={setDropdownData}
                                disabled={true}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={3}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <ComboboxField
                                className="inputBox"
                                // data={designs}
                                label="Design"
                                name="design"
                                code={`designCode-${building?.id}`}
                                description="designDesc"
                                setValue={building?.design || ""}
                                // getvalue={setDropdownData}
                                disabled={true}
                              />
                            </Col>

                            <Row>
                              <h5 className="mb-2 text-primary">Estimation</h5>
                            
                              <Col
                                xs={12}
                                md={6}
                                lg={3}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Tonnage"
                                  name="estTonnage"
                                  id="estTonnage"
                                  value={grandTotals?.totalWeight}
                                  // onChange={handleFormInputChange}
                                  disabled={true}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={6}
                                lg={3}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Estimate Cost"
                                  name="estCost"
                                  id="estCost"
                                  value={grandTotals?.totalPrice}
                                  // onChange={handleFormInputChange}
                                  disabled={true}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={4}
                                lg={3}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Overall Estimation Area"
                                  name="overallBuildingArea"
                                  value={`${getOverallBuildingArea?.toFixed(
                                    3
                                  )} Sqm`}
                                  readOnly
                                  disabled
                                />
                              </Col>
                              
                            </Row>
                          </Row>
                          {/* Only show content for active building */}
                          {activeBuildingId === building.id && (
                            <>
                              <div
                                className="accordion mt-3 mb-4"
                                id="accordionExample"
                              >
                                <div className="accordion-item">
                                  <h2 className="accordion-header">
                                    <Row className="accordion-button">
                                      <Col
                                        xs={1}
                                        md={1}
                                        lg={1}
                                        className="text-left arrowBtn"
                                      >
                                        <i
                                          className={`bi ${
                                            building.isCardVisible3
                                              ? "bi-chevron-right"
                                              : "bi-chevron-down"
                                          }`}
                                          // onClick={() =>
                                          //   toggleCardVisibility3(
                                          //     building.id
                                          //   )
                                          // }
                                        ></i>
                                      </Col>
                                      <Col
                                        xs={1}
                                        md={1}
                                        lg={1}
                                        className="text-center logoBtn"
                                      >
                                        <span className="iconLogo">BS</span>
                                      </Col>

                                      <Col xs={4} md={8} lg={8}>
                                        <span className="headerTitle">
                                          Components {building.id}
                                        </span>
                                        <span className="subHeaderTitle">
                                          Component details
                                        </span>
                                      </Col>
                                      <Col
                                        xs={4}
                                        md={2}
                                        lg={2}
                                        className="d-flex justify-content-end"
                                      >
                                        <button
                                          className="btnTable "
                                          // onClick={() => showCashRequestModal()}
                                          onClick={() =>
                                            setShowUploadModal(true)
                                          }
                                        >
                                          MTO Upload
                                        </button>
                                      </Col>
                                    </Row>
                                  </h2>
                                  <div
                                    className={`accordion-collapse collapse show ${
                                      building.isCardVisible3 ? "visible" : ""
                                    }`}
                                  >
                                    <div className="accordion-body pb-5">
                                      <Row>
                                        {/* First Column */}
                                        <Col
                                          xs={12}
                                          md={3}
                                          lg={3}
                                          className="commTopButtonRightLeftPadding"
                                        >
                                          {[
                                            "builtUpMembers",
                                            "leftSideWall",
                                            "rightSideWall",
                                            "frontEndWall",
                                            "backEndWall",
                                            "roof01",
                                            "roof02",
                                          ].map((option, index) => {
                                            const currentBuilding =
                                              buildings.find(
                                                (b) => b.id === activeBuildingId
                                              );
                                            const isChecked =
                                              currentBuilding
                                                ?.additionalComponents?.[
                                                option
                                              ] || false;

                                            return (
                                              <div
                                                className="form-check mb-2"
                                                key={option}
                                              >
                                                <input
                                                  className="form-check-input"
                                                  type="checkbox"
                                                  id={`check-${option}-${activeBuildingId}`}
                                                  style={{
                                                    width: "20px",
                                                    height: "20px",
                                                  }}
                                                  checked={isChecked}
                                                  onChange={(e) => {
                                                    const checked =
                                                      e.target.checked;
                                                    handleBuildingCheckboxChange(
                                                      activeBuildingId,
                                                      option,
                                                      checked
                                                    );
                                                  }}
                                                />
                                                <label
                                                  className="form-check-label ms-2"
                                                  htmlFor={`check-${option}-${activeBuildingId}`}
                                                  style={{ fontSize: "16px" }}
                                                >
                                                  {`${index + 1}. ${option
                                                    .replace(/([A-Z])/g, " $1")
                                                    .toUpperCase()}`}
                                                </label>
                                              </div>
                                            );
                                          })}
                                        </Col>
                                        {/* Second Column */}
                                        <Col
                                          xs={12}
                                          md={3}
                                          lg={3}
                                          className="commTopButtonRightLeftPadding"
                                        >
                                          {[
                                            "pipeStrut",
                                            "pipeBracing",
                                            "hr",
                                            "portalBracing",
                                            "leanTo",
                                            "canopy",
                                            "frameOpening",
                                          ].map((option, index) => {
                                            const currentBuilding =
                                              buildings.find(
                                                (b) => b.id === activeBuildingId
                                              );
                                            const isChecked =
                                              currentBuilding
                                                ?.additionalComponents?.[
                                                option
                                              ] || false;

                                            return (
                                              <div
                                                className="form-check mb-2"
                                                key={option}
                                              >
                                                <input
                                                  className="form-check-input"
                                                  type="checkbox"
                                                  id={`check-${option}-${activeBuildingId}`}
                                                  style={{
                                                    width: "20px",
                                                    height: "20px",
                                                  }}
                                                  checked={isChecked}
                                                  onChange={(e) => {
                                                    const checked =
                                                      e.target.checked;
                                                    handleBuildingCheckboxChange(
                                                      activeBuildingId,
                                                      option,
                                                      checked
                                                    );
                                                  }}
                                                />
                                                <label
                                                  className="form-check-label ms-2"
                                                  htmlFor={`check-${option}-${activeBuildingId}`}
                                                  style={{ fontSize: "16px" }}
                                                >
                                                  {`${index + 8}. ${option
                                                    .replace(/([A-Z])/g, " $1")
                                                    .toUpperCase()}`}
                                                </label>
                                              </div>
                                            );
                                          })}
                                        </Col>

                                        {/* Third Column */}
                                        <Col
                                          xs={12}
                                          md={3}
                                          lg={3}
                                          className="commTopButtonRightLeftPadding"
                                        >
                                          {[
                                            "partitionWall",
                                            "ridgeVentilator",
                                            "turboFans",
                                            "cageLadder",
                                            "craneBeam",
                                            "mezzanine",
                                            "fascia",
                                          ].map((option, index) => {
                                            const currentBuilding =
                                              buildings.find(
                                                (b) => b.id === activeBuildingId
                                              );
                                            const isChecked =
                                              currentBuilding
                                                ?.additionalComponents?.[
                                                option
                                              ] || false;

                                            return (
                                              <div
                                                className="form-check mb-2"
                                                key={option}
                                              >
                                                <input
                                                  className="form-check-input"
                                                  type="checkbox"
                                                  id={`check-${option}-${activeBuildingId}`}
                                                  style={{
                                                    width: "20px",
                                                    height: "20px",
                                                  }}
                                                  checked={isChecked}
                                                  onChange={(e) => {
                                                    const checked =
                                                      e.target.checked;
                                                    handleBuildingCheckboxChange(
                                                      activeBuildingId,
                                                      option,
                                                      checked
                                                    );
                                                  }}
                                                />
                                                <label
                                                  className="form-check-label ms-2"
                                                  htmlFor={`check-${option}-${activeBuildingId}`}
                                                  style={{ fontSize: "16px" }}
                                                >
                                                  {`${index + 15}. ${option
                                                    .replace(/([A-Z])/g, " $1")
                                                    .toUpperCase()}`}
                                                </label>
                                              </div>
                                            );
                                          })}
                                        </Col>
                                        {/* Fourth Column */}
                                        <Col
                                          xs={12}
                                          md={3}
                                          lg={3}
                                          className="commTopButtonRightLeftPadding"
                                        >
                                          {[
                                            "louvers",
                                            "structuralLouver",
                                            "industrialLouver",
                                            "staircase",
                                            "handrail",
                                            "hotRolled",
                                            "others",
                                          ].map((option, index) => {
                                            const currentBuilding =
                                              buildings.find(
                                                (b) => b.id === activeBuildingId
                                              );
                                            const isChecked =
                                              currentBuilding
                                                ?.additionalComponents?.[
                                                option
                                              ] || false;

                                            return (
                                              <div
                                                className="form-check mb-2"
                                                key={option}
                                              >
                                                <input
                                                  className="form-check-input"
                                                  type="checkbox"
                                                  id={`check-${option}-${activeBuildingId}`}
                                                  style={{
                                                    width: "20px",
                                                    height: "20px",
                                                  }}
                                                  checked={isChecked}
                                                  onChange={(e) => {
                                                    const checked =
                                                      e.target.checked;
                                                    handleBuildingCheckboxChange(
                                                      activeBuildingId,
                                                      option,
                                                      checked
                                                    );
                                                  }}
                                                />
                                                <label
                                                  className="form-check-label ms-2"
                                                  htmlFor={`check-${option}-${activeBuildingId}`}
                                                  style={{ fontSize: "16px" }}
                                                >
                                                  {`${index + 22}. ${option
                                                    .replace(/([A-Z])/g, " $1")
                                                    .toUpperCase()}`}
                                                </label>
                                              </div>
                                            );
                                          })}
                                        </Col>
                                      </Row>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {/* multiple buildings */}
                              <div className="accordion-body pb-5">
                                {Object.keys(componentBlocks)
                                  .filter((key) => {
                                    // Get the current active building
                                    const currentBuilding = buildings.find(
                                      (b) => b.id === activeBuildingId
                                    );
                                    // Check if this component is enabled for the active building
                                    return currentBuilding
                                      ?.additionalComponents?.[key];
                                  })
                                  .map((key) => {
                                    const block = componentBlocks[key];
                                    // const blockData =
                                    //   componentBlockData[key] || [];

                                    return (
                                      <div
                                        key={key}
                                        className="accordion mt-3 mb-4"
                                        id="accordionExample"
                                      >
                                        <div className="accordion-item">
                                          <h2 className="accordion-header">
                                            <Row className="accordion-button">
                                              <Col
                                                xs={1}
                                                className="text-left arrowBtn"
                                              >
                                                <i
                                                  className={`bi ${
                                                    visibleBlocks[key]
                                                      ? "bi-chevron-right"
                                                      : "bi-chevron-down"
                                                  }`}
                                                  onClick={() =>
                                                    toggleCardVisibility(key)
                                                  }
                                                ></i>
                                              </Col>

                                              <Col
                                                xs={1}
                                                className="text-center logoBtn"
                                              >
                                                <span className="iconLogo">
                                                  {block.icon}
                                                </span>
                                              </Col>

                                              <Col xs={4}>
                                                <span className="headerTitle">
                                                  {block.title} {building.id}
                                                </span>
                                                <span className="subHeaderTitle">
                                                  {block.subtitle}
                                                </span>
                                              </Col>

                                              {/* Header buttons */}
                                              <Col
                                                xs={12}
                                                md={6}
                                                lg={6}
                                                className="headerButtonAlign d-flex justify-content-end"
                                              >
                                                <Col xs={6} md={3} lg={2}>
                                                  <button
                                                    className="btnTable"
                                                    onClick={() =>
                                                      addEmptyRowToComponent(
                                                        key
                                                      )
                                                    }
                                                  >
                                                    +
                                                  </button>
                                                </Col>
                                                <Col xs={6} md={3} lg={2}>
                                                  <button
                                                    className="btnTable"
                                                    onClick={() =>
                                                      addProductDetails(
                                                        key,
                                                        true
                                                      )
                                                    }
                                                  >
                                                    <i className="bi bi-plus-lg"></i>{" "}
                                                    Add
                                                  </button>
                                                </Col>
                                              </Col>
                                            </Row>
                                          </h2>

                                          <div
                                            className={`accordion-collapse collapse show ${
                                              visibleBlocks[key]
                                                ? "visible"
                                                : ""
                                            }`}
                                          >
                                                                                      <div className="accordion-body">
                                              {/* Additional Fields for Each Component */}
                                              {block.fields && block.fields.length > 0 && (
                                                <Row className="mb-3">
                                                  {block.fields.map((field, index) => (
                                                    <Col
                                                      key={field.name}
                                                      xs={12}
                                                      md={6}
                                                      lg={4}
                                                    ></Col>
                                                  ))}
                                                </Row>
                                              )}
                                            
                                              {/* Data Table */}
                                              <Row className="pt-2 pb-4">
                                                <Col xs={12} md={12} lg={12}>
                                                  <div
                                                    style={{
                                                      maxHeight: "400px",
                                                      overflowY: "auto",
                                                      overflowX: "auto",
                                                    }}
                                                  >
                                                    <Profiler 
                                                      id={`DataTable-${key}`} 
                                                      onRender={(id, phase, actualDuration) => {
                                                        if (actualDuration > 100) {
                                                          console.log(`⚠️ ${id} (${phase}) took ${actualDuration.toFixed(2)}ms`);
                                                        }
                                                      }}
                                                    >
                                                      <TableComponent 
                                                        identifier={key}
                                                        isComponent={true}
                                                        componentBlockData={componentBlockData}
                                                        activeBuildingId={activeBuildingId}
                                                        getCurrentBlockData={getCurrentBlockData}
                                                        getProductDetailsCol={getProductDetailsCol}
                                                      />
                                                    </Profiler>
                                                  </div>
                                                </Col>
                                              </Row>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    );
                                  })}
                              </div>
                            </>
                          )}
                        </div>
                      ))}
                      <div className="overall-total-container mt-4">
                        <div className="d-flex justify-content-start flex-column align-items-start">
                          <div style={{ fontWeight: 600 }}>
                            Overall Total Weight:&nbsp;
                            {overallTotalWeight.toFixed(3)} kg
                          </div>

                          <div style={{ fontWeight: 600 }}>
                            Overall Total Price:&nbsp;₹
                            {overallTotalPrice.toFixed(3)}
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* Remraks */}
                    <div
                      className="tab-content pt-2"
                      style={{ overflowY: "auto" }}
                    >
                      {buildings.map((building, index) => (
                        <div
                          key={building.id}
                          className={`tab-pane fade ${
                            activeBuildingId === building.id
                              ? "show active"
                              : ""
                          }`}
                        >
                          {/* Only show content for active building */}
                          {activeBuildingId === building.id && (
                            <div
                              className="accordion mt-3 mb-4"
                              id="accordionExample"
                            >
                              <div className="accordion-item">
                                <h2 className="accordion-header">
                                  <Row className="accordion-button">
                                    <Col
                                      xs={1}
                                      md={1}
                                      lg={1}
                                      className="text-left arrowBtn"
                                    >
                                      <i
                                        className={`bi ${
                                          building.isCardVisible10
                                            ? "bi-chevron-right"
                                            : "bi-chevron-down"
                                        }`}
                                        onClick={() =>
                                          toggleCardVisibility10(building.id)
                                        }
                                      ></i>
                                    </Col>
                                    <Col
                                      xs={1}
                                      md={1}
                                      lg={1}
                                      className="text-center logoBtn"
                                    >
                                      <span className="iconLogo">AB</span>
                                    </Col>
                                    <Col xs={4} md={4} lg={4}>
                                      <span className="headerTitle">
                                        Remarks {building.id}
                                      </span>
                                      <span className="subHeaderTitle">
                                        Remarks Section
                                      </span>
                                    </Col>
                                  </Row>
                                </h2>
                                <div
                                  className={`accordion-collapse collapse show ${
                                    building.isCardVisible10 ? "visible" : ""
                                  }`}
                                >
                                  <div className="accordion-body pb-5">
                                    <Row className="p-4">
                                      <Col xs={12} md={12} lg={12}>
                                        <RichTextEditor
                                          value={
                                            building?.remarksEstimationCreation ||
                                            ""
                                          }
                                          onChange={(content) =>
                                            handleRemarks(content, building.id)
                                          }
                                        />
                                      </Col>
                                    </Row>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                    {/* estimation specification input fileds */}
                    <div
                      className="tab-content pt-2"
                      style={{ overflowY: "auto" }}
                    >
                      {buildings.map((building, index) => (
                        <div
                          key={building.id}
                          className={`tab-pane fade ${
                            activeBuildingId === building.id
                              ? "show active"
                              : ""
                          }`}
                        >
                          {/* Only show content for active building */}
                          {activeBuildingId === building.id && (
                            <div
                              className="accordion mt-3 mb-4"
                              id="accordionExample"
                            >
                              <div className="accordion-item">
                                <h2 className="accordion-header">
                                  <Row className="accordion-button">
                                    <Col
                                      xs={1}
                                      md={1}
                                      lg={1}
                                      className="text-left arrowBtn"
                                    >
                                      <i
                                        className={`bi ${
                                          building.isCardVisible10
                                            ? "bi-chevron-right"
                                            : "bi-chevron-down"
                                        }`}
                                        onClick={() =>
                                          toggleCardVisibility10(building.id)
                                        }
                                      ></i>
                                    </Col>
                                    <Col
                                      xs={1}
                                      md={1}
                                      lg={1}
                                      className="text-center logoBtn"
                                    >
                                      <span className="iconLogo">AB</span>
                                    </Col>
                                    <Col xs={4} md={4} lg={4}>
                                      <span className="headerTitle">
                                        Estimation Specification {building.id}
                                      </span>
                                      <span className="subHeaderTitle">
                                        Estimation Specification
                                      </span>
                                    </Col>
                                  </Row>
                                </h2>
                                <div
                                  className={`accordion-collapse collapse show ${
                                    building.isCardVisible10 ? "visible" : ""
                                  }`}
                                >
                                  <div className="accordion-body pb-5">
                                    <Row className="p-4">
                                      <Col
                                        xs={12}
                                        md={3}
                                        lg={3}
                                        className="commLeftRightPadding"
                                      >
                                        <InputField
                                          label="Roof Bracing"
                                          className="inputBox"
                                          name="roofBracing"
                                          value={building?.roofBracing || ""}
                                          onChange={(e) =>
                                            handleBuildingFieldChange(
                                              building.id,
                                              "roofBracing",
                                              e.target.value
                                            )
                                          }
                                        />
                                      </Col>
                                      <Col
                                        xs={12}
                                        md={3}
                                        lg={3}
                                        className="commLeftRightPadding"
                                      >
                                        <InputField
                                          label="Side Bracing"
                                          className="inputBox"
                                          name="sideBracing"
                                          value={building?.sideBracing || ""}
                                          onChange={(e) =>
                                            handleBuildingFieldChange(
                                              building.id,
                                              "sideBracing",
                                              e.target.value
                                            )
                                          }
                                        />
                                      </Col>
                                      <Col
                                        xs={12}
                                        md={3}
                                        lg={3}
                                        className="commLeftRightPadding"
                                      >
                                        <InputField
                                          label="Open wall / Masonary Conditions"
                                          className="inputBox"
                                          name="openWallMasonaryConditions"
                                          value={
                                            building?.openWallMasonaryConditions ||
                                            ""
                                          }
                                          onChange={(e) =>
                                            handleBuildingFieldChange(
                                              building.id,
                                              "openWallMasonaryConditions",
                                              e.target.value
                                            )
                                          }
                                        />
                                      </Col>
                                    </Row>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </Col>
            </Row>

            {/* Save Button */}
            <div className="text-end my-4">
              <button
                className="btn btn-success"
                // className="btn btn-primary mt-4  "
                onClick={handleDraft}
                disabled={disabled}
                // disabled={disabled}
              >
                Save as Draft
              </button>
              <button
                className="btn btn-success"
                disabled={disabled}
                onClick={handleSave}
              >
                Save
              </button>
            </div>
          </div>
        </Col>
        {/* Blocks */}
        {/*  */}
      </Row>
      <EstimateMaterialSelectionModal
        show={modalShow}
        onHide={hideModal}
        onselectedcatdata={(selected) => {
          if (activeBlockIndex !== null) {
            handleGetSelectedMaterial(selected, activeBlockIndex);
          } else if (activeComponentKey) {
            handleGetSelectedMaterialForComponent(selected, activeComponentKey);
          }
        }}
      />
      <EstimateUploadDataViewModal
        show={showDataModal}
        onHide={() => setShowDataModal(false)}
        data={parsedData}
        columns={MTOColumns}
        title="Uploaded MTO"
        file={uploadedFile}
        onClick={handleSaveUpload}
        // disabled={disabled}
        // loading={loading}
      />
      <EstimateUploadModal
        show={showUploadModal}
        onHide={() => setShowUploadModal(false)}
        onUploadComplete={handleUploadComplete}
      />
    </main>
  );
};

export default EstimationCreation;
